{
  "all-string": "All",
  "monday-string": "Monday",
  "tuesday-string": "Tuesday",
  "wednesday-string": "Wednesday",
  "thursday-string": "Thursday",
  "friday-string": "Friday",
  "saturday-string": "Saturday",
  "sunday-string": "Sunday",
  "reset-string": "Reset",
  "select-string": "Select",
  "selectAndReopen-string": "Select & reopen",
  "save-string": "Save",
  "done-string": "Done",
  "cancel-string": "Cancel",
  "discardChanges-string": "Discard",
  "profileUnsavedLeaveAlertTitle-string": "DISCARD PROFILE CHANGES",
  "profileUnsavedLeaveAlertText-string": "You have unsaved profile changes. Discard these changes?",
  "coachSettingsUnsavedLeaveAlertTitle-string": "DISCARD SETTINGS CHANGES",
  "coachSettingsUnsavedLeaveAlertText-string": "You have unsaved settings changes. Discard these changes?",
  "delete-string": "Delete",
  "replace-string": "Replace",
  "modify-string": "Modify",
  "unlink-string": "Unlink",
  "create-string": "Create",
  "okay-string": "Okay",
  "weeklyView-string": "Week View",
  "workoutsView-string": "Workouts view",
  "blockView-string": "Block View",
  "oldView-string": "Old view",
  "blockViewUpdateTitle-string": "Introducing the new Workouts view",
  "blockViewUpdateBadge-string": "Major update",
  "blockViewUpdateIntro-string": "We've worked hard on this update. In the new Workouts view, you'll have all the features from before, plus:",
  "blockViewUpdateBullet1-string": "Reorder sets.",
  "blockViewUpdateBullet2-string": "Use the automatic exercise search bar.",
  "blockViewUpdateBullet3-string": "Copy and paste sets.",
  "blockViewUpdateBullet4-string": "Copy and paste exercises.",
  "blockViewUpdateBullet5-string": "Move exercises between workout sessions.",
  "blockViewUpdateButton-string": "Try it out",
  "blockViewTutorialTitle-string": "Learn how to use the new Workouts view",
  "blockViewTutorialCta-string": "View tutorial",
  "blockViewFeedbackCta-string": "Send feedback",
  "blockViewOldViewHint-string": "The old view is temporarily available. If you want to access it, click",
  "blockViewOldViewLink-string": "here",
  "blockViewRevertTitle-string": "Go back to the old Workouts view",
  "blockViewRevertSubtitle-string": "Tell us what you don't like or what's missing so we can improve the new view. If you want to contact us more directly, write to us on Instagram @efortapp.",
  "blockViewRevertPlaceholder-string": "Tell us what you would like us to improve in the new view...",
  "blockViewRevertButton-string": "Go back to the old view",
  "legacyPlanViewTemporaryNotice-string": "This view is temporarily available and will be removed soon.",
  "legacyBlockViewSettingsTitle-string": "Workouts view (temporary)",
  "legacyBlockViewOptionLegacy-string": "Old",
  "legacyBlockViewOptionNew-string": "New",
  "athleteCountOne-string": "{{count}} Athlete",
  "athleteCount-string": "{{count}} Athletes",
  "yes-string": "Yes",
  "changeName-string": "Change name",
  "rename-string": "Rename",
  "back-string": "Back",
  "currency-string": "$",
  "confirm-string": "Confirm",
  "edit-string": "Edit",
  "change-string": "Change",
  "manage-string": "Manage",
  "spanish-string": "Spanish",
  "english-string": "English",
  "accept-string": "Accept",
  "invite-string": "Invite",
  "link-string": "Link",
  "notLink-string": "Not link",
  "videoLink-string": "Video Link",
  "invalidUrl-string": "Invalid URL format",
  "help-string": "Help",
  "copy-string": "Copy",
  "paste-string": "Paste",
  "close-string": "Close",
  "enable-string": "Enable",
  "viewTutorial-string": "View tutorial",
  "optional-string": "(Optional)",
  "pressEnterToSelectFirstResult-string": "Press Enter to select the first result",
  "enterSelectsFirstHint-string": "↵ Enter selects first",
  "horizontalScrollHint-string": "Use ⇧ + Wheel for horizontal scroll",

  "onboardingNameTitle-string": "Hello, what should we call you?",
  "onboardingNameSubtitle-string": "This is the name you and your athletes will see",
  "onboardingNamePlaceholder-string": "Name",
  "onboardingAthletesCountTitle-string": "How many athletes do you have at the moment?",
  "onboardingAthletesCount1-5-string": "1 - 5 athletes",
  "onboardingAthletesCount6-15-string": "6 - 15 athletes",
  "onboardingAthletesCount16-30-string": "16 - 30 athletes",
  "onboardingAthletesCount31-50-string": "31 - 50 athletes",
  "onboardingAthletesCount50plus-string": "More than 50 athletes",
  "onboardingAthleteTypeTitle-string": "What kind of athletes do you coach?",
  "onboardingAthleteTypeSubtitle-string": "This helps customize your experience",
  "onboardingAthleteTypePowerlifters-string": "Powerlifters",
  "onboardingAthleteTypeBodybuilders-string": "Bodybuilders",
  "onboardingAthleteTypeOther-string": "Other",
  "onboardingFeaturesTitle-string": "What are you planning on using Efort Coach for?",
  "onboardingFeaturesSubtitle-string": "You can always add more later",
  "onboardingFeaturePrograms-string": "Create training blocks",
  "onboardingFeatureVideos-string": "Receive videos and communicate with my athletes",
  "onboardingFeatureCompetitions-string": "Plan powerlifting competitions",
  "onboardingFeatureBilling-string": "Track my athletes' payments",
  "onboardingFeatureApplications-string": "Manage new coaching inquiries",
  "onboardingFeatureForms-string": "Automate forms",
  "onboardingLogoTitle-string": "Add your logo",
  "onboardingLogoSubtitle-string": "Customize the app with your brand",
  "onboardingLogoPlaceholder-string": "LOGO",
  "onboardingLogoUploading-string": "Uploading...",
  "onboardingLogoChangeFile-string": "Change file",
  "onboardingLogoChooseFile-string": "Choose file",
  "onboardingLogoDragDrop-string": "or drag and drop your image here",
  "onboardingLogoErrorInvalidType-string": "Please select a valid image file (JPEG, PNG, GIF, or WebP)",
  "onboardingLogoErrorFileSize-string": "Image size must be less than 5MB",
  "onboardingLogoErrorReadFile-string": "Failed to read the selected file",
  "onboardingLogoErrorProcessing-string": "An error occurred while processing the image",
  "onboardingLogoSkip-string": "Skip",
  "onboardingPreferencesTitle-string": "Choose your preferences",
  "onboardingPreferencesSubtitle-string": "You can always change them later",
  "onboardingPreferenceMeasurementUnit-string": "Measurement unit",
  "onboardingPreferenceIntensityRating-string": "Intensity rating",
  "openAthlete-string": "Open athlete",
  "expandChat-string": "Expand chat",
  "minimizeChat-string": "Minimize chat",
  "showChat-string": "Show chat",
  "hideChat-string": "Hide chat",
  "onboardingPreferenceIntensityRatingTooltip-string": "Select the option to prescribe rate load intensities as either a Rate of Perceived Exertion (RPE) or Reps in Reserve (RIR)",
  "onboardingPreferenceShowExerciseStats-string": "Show exercise statistics to athletes",
  "onboardingPreferenceShowExerciseStatsTooltip-string": "Select if you want athletes to see their exercise statistics (e1RM, tonnage, etc.) while training.",
  "onboardingPreferenceShowPriority-string": "Show set priority to you and your athletes?",
  "onboardingPreferenceShowPriorityTooltip-string": "Select if you want to display the priority of each set (high, medium, low) in training programs.",
  "onboardingPreferenceKg-string": "kg",
  "onboardingPreferenceLbs-string": "lbs",
  "onboardingPreferenceRPE-string": "RPE",
  "onboardingPreferenceRIR-string": "RIR",
  "onboardingPreferenceShow-string": "show",
  "onboardingPreferenceHide-string": "hide",
  "onboardingBuildApp-string": "Build your app",

  "optionalFeature-string": "Optional feature",
  "planWeeklyProgressionMainLifts-string": "Plan the weekly progression of the main lifts",
  "blocksWorkWithoutFeature-string": "You can create blocks without this feature. Enable it only if you want more advanced powerlifting programming tools.",
  "blockOverview-string": "Block overview",
  "blockOverviewAvailableText-string": "The block overview is available when you enable the optional programming feature in the block dashboard.",

  "offlineAlertTitle-string": "You are currently offline",
  "offlineAlertText-string": "To work with an athlete, you have to download their plan before going offline",
  "offlineFormsInformationMissing-string": "Some forms might be missing in offline mode.",
  "offlineCompetitionsInformationMissing-string": "Some competition might be missing in offline mode.",

  "deletePredefinedExerciseAlertTitle-string": "DELETE PREDEFINED EXERCISE",
  "deletePredefinedExerciseAlertText-string": "Are you sure you want to delete the predefined exercise?",
  "deletePredefinedAttributeAlertTitle-string": "DELETE PREDEFINED MODIFIER",
  "deletePredefinedAttributeAlertText-string": "Are you sure you want to delete the predefined modifier?",
  "sureToDelete-string": "Are you sure you want to delete '{{itemName}}'?",

  "automaticProtocolsAlertTitle-string": "REPLACE EXERCISE SETS",
  "automaticProtocolsAlertText-string": "This exercise already has sets filled in. Do you want to replace the sets for week 1 with the ones from the protocol?",

  "noProtocolExerciseAlertTitle-string": "SELECT AN EXERCISE FIRST",
  "noProtocolExerciseAlertText-string": "You need to choose which exercise goes in this slot before setting its protocol.",

  "emptyProtocolsTitle-string": "No Protocols Defined",
  "emptyProtocolsText-string": "Add protocols to enable this block's summary",

  "protocolSyntaxTitle-string": "SUPPORTED PROTOCOLS",
  "protocolSyntaxText-string": "Here are examples of different protocol cases where sets will be automatically created for the exercise:\n\n'Ramp 3x4 @7'\n\n'3x4 @5'\n\n'Single @5'\n\n'x4 @5'\n\n'x4 @4-5-6'\n\n'175-180-185 x4'\n\n'3x5x200'",

  "protocolDetectionTitle-string": "NO SPECIFIC PROTOCOL DETECTED",
  "protocolDetectionText-string": "Here are examples of different protocol cases where sets will be automatically created for the exercise:\n\n'Ramp 3x4 @7'\n\n'3x4 @5'\n\n'Single @5'\n\n'x4 @5'\n\n'x4 @4-5-6'\n\n'175-180-185 x4'\n\n'3x5x200'",

  "actualWithDataProtocolWarningTitle-string": "SETS ALREADY CONTAIN DATA",
  "actualWithDataProtocolWarningText-string": "Changing the protocol will regenerate the sets and overwrite existing data. Are you sure you want to modify the protocol for this exercise?",

  "actualWithDataCopyProtocolWarningTitle-string": "SETS ALREADY CONTAIN DATA",
  "actualWithDataCopyProtocolWarningText-string": "Copying this slot will replace the exercise in week {{week}}, including its modifiers and sets. Are you sure you want to overwrite existing data?",

  "actualWithDataCopyWeekProtocolsWarningTitle-string": "SETS ALREADY CONTAIN DATA",
  "actualWithDataCopyWeekProtocolsWarningText-string": "Copying this week will replace all exercises in week {{week}}, including their modifiers and sets. Are you sure you want to overwrite existing data?",

  "pasteSetsConfirmationTitle-string": "REPLACE SETS",
  "pasteSetsConfirmationMessage-string": "Sets already have data, are you sure you want to replace sets?",

  "search-string": "Search",

  "dashboard-string": "Dashboard",

  "TITOL INDEX/LOGIN": "",

  "welcome-string": "Welcome",
  "termsAndConditions-string": "Terms and conditions",
  "privacyPolicy-string": "Privacy policy",
  "welcomeToEfortCoach-string": "Welcome to Efort Coach",
  "theAppForCoaches-string": "The app for powerlifting coaches",
  "yourEmail-string": "Your email",
  "yourPassword-string": "Your password",
  "signUp-string": "Sign up",
  "signIn-string": "Sign in",
  "alreadyHaveAccount-string": "Already have an account?",
  "tryEfortCoachFree-string": "Try Efort Coach free for 10 days",
  "noCreditCardNeeded-string": "No credit card needed. Unlimited use. No commitment.",
  "byContinuingYouAgree-string": "By continuing, you agree to Efort Coach",
  "and-string": "and",
  "replaceSpreadsheets-string": "Replace hundreds of spreadsheets with Efort Coach",
  "trustedByCoaches-string": "Trusted by experienced coaches",
  "password-string": "Password",
  "passwordMinLength-string": "Password must be at least 6 characters long",
  "emailRequired-string": "Email is required",
  "forgotPassword-string": "Forgot password?",
  "passwordResetEmailSent-string": "Password reset email sent! Check your inbox.",
  "resetYourPassword-string": "Reset your password",
  "resetPasswordDescription-string": "Enter the email address associated with your account, and we'll send you a link to reset your password.",
  "continue-string": "Continue",
  "returnToSignIn-string": "Return to Sign In",
  "checkYourInbox-string": "Check your inbox",
  "checkInboxDescription-string": "Thanks! If {email} matches an email address we have on file, then we've sent you an email containing further instructions for resetting your password.\n\nIf you haven't received an email in 5 minutes, check your spam, resend, or try a different email address.",
  "resend-string": "Resend",
  "welcomeBack-string": "Welcome back",
  "signInToYourAccount-string": "Sign in to your account",
  "newToEfortCoach-string": "New to Efort Coach?",
  "userNotFound-string": "User not found",
  "wrongPassword-string": "Incorrect password",
  "invalidCredentials-string": "Invalid email or password",
  "emailAlreadyUser-string": "Email is already in use. Log in with your password, or with Google in a compatible browser (Chrome, Safari or Edge).",
  "passwordNotLongEnough-string": "Password has to be at least 6 characters.",
  "invalidEmail-string": "Invalid email. Check that there aren't any mistakes.",
  "allRightsReserved-string": "© 2026 Efort Systems S.L.\nAll rights reserved.",
  "welcomeToEfortCoachExclamation-string": "Welcome to Efort Coach!",
  "startYourFreeTrial-string": "Start your 10 day free trial",
  "whatsIncluded-string": "What's included in Efort Coach?",
  "bulletText1-string": "Full access to all coaching tools",
  "bulletText2-string": "Centralized athlete management.",
  "bulletText3-string": "Your athletes receive their plans in Efort.",
  "bulletText4-string": "Unlimited video storage.",
  "bulletText5-string": "Coach mobile app access.",
  "yourFullName-string": "Your full name",
  "iHaveRead-string": "I have read and accept the",
  "lowercasedTermsAndConditions-string": "terms and conditions",
  "haveToAcceptTerms-string": "You have to accept the terms and conditions",
  "getStarted-string": "Get started",
  "incompatibleNavigator-string": "¡Oops! This navigator is not compatible. Please, access using another navigator (Google Chrome, Safari...)",
  "resetAthletesAlertTitle-string": "RESET COMPLETED ATHLETES",
  "resetAthletesAlertText-string": "Are you sure you want to reset the completed athletes?",

  "TITOL TUTORIAL STEPS": "",

  "tutorials-string": "Tutorials",
  "viewTutorials-string": "View tutorials",
  "learnToUseEfortCoach-string": "Learn to use Efort Coach",
  "upgradePlan-string": "Upgrade your plan",
  "completedTutorialSteps-string": "{{completedSteps}} / 4 Completed",
  "gettingStarted-string": "Getting Started",
  "learnEfortTutorial-string": "{{coachName}}, follow these steps to get started.",
  "tutorialStep1-string": "Create your account",
  "tutorialStep1text1-string": "Create your Efort Coach account.",
  "tutorialStep2-string": "Check your athletes' app",
  "tutorialStep2text1-string": "Discover what your athletes will experience with Efort.",
  "tutorialStep2text2-string": "Check the athlete app",
  "tutorialStep3-string": "Build your first workout",
  "tutorialStep3text1-string": "Add your first exercise to a workout.",
  "tutorialStep3text2-string": "Build workout",
  "tutorialStep4-string": "Invite your athletes",
  "tutorialStep4text1-string": "See how easy it is to invite your athletes to the app.",
  "tutorialStep4text2-string": "Invite athletes",
  "athleteAppOnboardingTitle-string": "This is what your athletes will see",
  "athleteAppPreviewTitle-string": "Preview athlete app",
  "athleteAppOnboarding1-string": "To try the app for yourself, download Efort on your phone (",
  "athleteAppOnboarding2-string": "Google Play & App Store) and log in with your account:",
  "athleteAppOnboarding-markCompleted": "Mark as completed",
  "athleteAppOnboardingHome-string": "Home",
  "athleteAppOnboardingExercise-string": "Exercise",
  "athleteAppOnboardingWorkouts-string": "Workouts",
  "athleteAppOnboardingChat-string": "Chat",
  "athleteAppOnboardingCalendar-string": "Calendar",
  "athleteAppOnboardingCompetitions-string": "Competitions",
  "athleteAppOnboardingStatistics-string": "Statistics",
  "athleteAppOnboardingBlocks-string": "Blocks",
  "athleteAppOnboardingExercises-string": "Exercises",
  "bookCall-string": "Book a call",
  "feedbackText-string": "Hello {{coachName}}, thanks for using Efort Coach. Let us know if there are any features you'd like to see.",
  "blockViewFeedbackTitle-string": "New Workouts view feedback",
  "blockViewFeedbackText-string": "{{coachName}}, share your thoughts on the new view so we can make it better.",
  "blockViewFeedbackPlaceholder-string": "Your feedback",
  "sendFeedback-string": "SEND FEEDBACK",
  "sendFeedbackPlaceholder-string": "Your feedback",
  "feedbackThanksTitle-string": "Thanks for sharing your feedback",
  "feedbackThanksDescription-string": "We'll review it and take it into account to keep improving Efort Coach.",

  "cookiePanelText-string": "Efort Coach uses cookies. See",
  "cookiePanelLink-string": "Cookie Notice",
  "cookiePanelTextEnd-string": "for details.",
  "cookiePanelReject-string": "Decline",
  "cookiePanelAccept-string": "Accept",

  "tutorialCompetitionGameplan-string": "Learn to create competitions and build game plans for your athletes.",
  "tutorialLibraryForms-string": "Learn how to set up weekly and block forms that are automatically sent to your athletes.",
  "tutorialLibraryWorkouts-string": "Quickly learn how to use the workout library.",
  "tutorialBilling-string": "Learn how to use billing to track your athletes' payments.",
  "tutorialProgramDashboard-string": "In the Dashboard view, plan the progression of the main lifts across the block. Learn how to build a complete block.",
  "tutorialProgramWorkouts-string": "In the Workouts view, create and edit the sessions your athletes will see from their app. Learn how to do it.",
  "tutorialCalendarMacrocycle-string": "Program the progression of the main lifts across several blocks. Learn how to do it.",

  "TITOL WHATS NEW": "",

  "whatsNew-string": "What's new",
  "viewWhatsNew-string": "View what's new",
  "productUpdatesForEfortCoach-string": "Product updates for Efort Coach",
  "currentVersion-string": "Current version: {{version}}",
  "olderUpdates-string": "…there were updates before this too",
  "wantToRequestFeature-string": "Want to request a feature or comment on these updates?",
  "sendUsYourIdeas-string": "Send us your ideas so we know what to build next. We read every message.",
  "gotIt-string": "Got it",
  "accessTutorials-string": "Access tutorials →",
  "sendFeedbackLowercased-string": "Send feedback",

  "v200WorkoutsViewRedesign-string": "Completely redesigned Workouts view in Program",
  "v200WorkoutsViewRedesignIntro-string": "We've completely redesigned the Workouts view in Program to make it much easier to navigate. You can now:",
  "v200WorkoutsViewRedesignBullet1-string": "Reorder sets.",
  "v200WorkoutsViewRedesignBullet2-string": "Use the automatic exercise search bar.",
  "v200WorkoutsViewRedesignBullet3-string": "Copy and paste sets.",
  "v200WorkoutsViewRedesignBullet4-string": "Copy and paste exercises.",
  "v200WorkoutsViewRedesignBullet5-string": "Move exercises between workout sessions.",

  "v201BlockExportAllWeeks-string": "Export all block weeks by default",
  "v201BlockExportAllWeeksDesc-string": "When you export a block to the Block library, all weeks of the block are now exported by default.",
  "v201MasterCategoryWRPF-string": "Master category and WRPF federation in Competitions",
  "v201MasterCategoryWRPFDesc-string": "We've added the Master age category and the WRPF federation to Competitions.",

  "v202ImprovedVideoQuality-string": "Improved video quality",
  "v202ImprovedVideoQualityDesc-string": "Improved the resolution of videos sent by athletes through the chat.",
  "v202EmojisInChat-string": "Emojis in chat",
  "v202EmojisInChatDesc-string": "You can now send emojis to your athletes in the chat.",
  "v202RemovedCompetitorStatus-string": "Removed athlete competitor status",
  "v202RemovedCompetitorStatusDesc-string": "We have removed the competitor status of athletes. You can now add any athlete to a powerlifting competition.",

  "v203BlocksListRedesign-string": "Redesigned blocks list",
  "v203BlocksListRedesignDesc-string": "We have redesigned the blocks list. Blocks are now organized in folders. You can now see which blocks have been completed and which have not yet. You can also drag blocks between folders to keep your athletes' blocks organized.",
  "v203WorkoutLibraryUpdated-string": "Improvements to Workout library",
  "v203WorkoutLibraryUpdatedDesc-string": "We've updated the Workout library to make building workouts faster.",
  "v203ReorderLibrary-string": "Reorder workouts and blocks in your library",
  "v203ReorderLibraryDesc-string": "You can now reorder workouts and blocks from your Workout and Block libraries.",
  "v203SettingsProfileVisual-string": "Minor visual updates in Settings and Athlete profile",
  "v203SettingsProfileVisualDesc-string": "Small visual tweaks to Settings and the athlete profile view to make it look cleaner.",

  "v129ExerciseSearchbar-string": "New exercise search bar in Dashboard",
  "v129ExerciseSearchbarDesc-string": "On the Dashboard, you can now type the exercise name you want and the search bar will select the exercise and modifiers for you. You'll also get quick access to recently used exercises for each athlete.",
  "v129StatisticsImprovements-string": "Statistics improvements",
  "v129StatisticsImprovementsDesc-string": "You can now select the specific slots you want to analyze. When you select a block, exercise suggestions appear automatically so statistics are more accessible and easier to use. We also improved the interface to make it clearer.",
  "v129ApplicationsIndicator-string": "New applications indicator",
  "v129ApplicationsIndicatorDesc-string": "When you receive a new coaching application, you'll see a dot next to the Applications section in the sidebar when you open Efort Coach to indicate there's a new application to review.",

  "v130SmallProgramImprovements-string": "Small program improvements",
  "v130SmallProgramImprovementsDesc-string": "We've made small improvements to some views (adding exercise links, linking exercises to slots...). We've also made internal improvements to prepare for a big update coming soon.",
  "v130ChatMessageTimeFix-string": "Fixed chat message times",
  "v130ChatMessageTimeFixDesc-string": "We've fixed an issue where message times in the chat were sometimes displayed incorrectly. Times are now accurate and reliable.",

  "v128SimplifiedModifiers-string": "Simplified modifiers and exercise categories",
  "v128SimplifiedModifiersDesc-string": "We've removed the weightlifting exercise category and modifier subtypes to make modifiers and categories easier to understand and use.",
  "v128ModifiersLibrary-string": "New modifiers library",
  "v128ModifiersLibraryDesc-string": "We've added a modifiers library where you can view all modifiers, create new ones, and reorder them.",
  "v128ProgramImprovements-string": "Small interface improvements in Program",
  "v128ProgramImprovementsDesc-string": "We've made small visual tweaks in the Program section.",

  "v127OpenAthleteFromChat-string": "Open athletes directly from chat",
  "v127OpenAthleteFromChatDesc-string": "You can now open an athlete's profile straight from the chat by clicking the access button next to their name.",
  "v127OpenBlockFromCalendar-string": "Open blocks from the calendar",
  "v127OpenBlockFromCalendarDesc-string": "From the calendar, you can now open a block in the Program section by clicking the access button next to the block's name.",
  "v127SmallUIImprovements-string": "User interface improvements",
  "v127SmallUIImprovementsDesc-string": "We've added small help messages when you hover over some icons, disabled buttons when an action isn't available, and improved parts of the Program section so it's easier to see what to do next when building a block from the dashboard.",

  "v126AthleteOverviewRedesign-string": "Completely redesigned athlete overview",
  "v126AthleteOverviewRedesignDesc-string": "We've completely redesigned the athlete overview to make it easier to understand each athlete's current situation. At a glance, you can see the status of their current block, the date of their next competition, weekly workouts, unread messages and videos, average bodyweight, trac trends, forms, and add private notes that only you can see, all organized by week with a simple week picker.",
  "v126FormsNotifications-string": "Form updates indicator",
  "v126FormsNotificationsDesc-string": "When an athlete submits a form, you'll see a small dot next to the Forms tab and a marker in the athlete overview so you can quickly spot forms with new answers to review.",
  "v126ActiveBlockAndWeeks-string": "Improved block and week detection logic",
  "v126ActiveBlockAndWeeksDesc-string": "We've improved how the current block and week are detected so they match the athlete's real training timeline. The week shown in the sidebar now always reflects the week the athlete is actually in, even if no workouts are created yet. When a week has no workouts, its number appears in red so you know you need to add them.",

  "v125UpdatedDashboardDesign-string": "Minor updates to the main dashboard",
  "v125UpdatedDashboardDesignDesc-string": "We've made small visual tweaks to the main dashboard.",
  "v125InviteMultipleAthletes-string": "Invite multiple athletes at once",
  "v125InviteMultipleAthletesDesc-string": "You can now invite multiple athletes in one go, and we've updated the athlete user guide, which you can download from the Invite Athlete view or from here.",
  "v125DownloadAthleteGuideIntro-string": "Download the athlete guide:",
  "v125DownloadAthleteGuide-string": "Download the athlete guide",
  "v125DefaultBlockView-string": "Default block view",
  "v125DefaultBlockViewDesc-string": "We've added a new \"Default block view\" setting that lets you choose whether blocks open in the Workouts view or in the Dashboard view by default.",

  "v124NewOptionsInSettings-string": "New options in Settings",
  "v124NewOptionsIntro-string": "Two new options were added in Settings:",
  "v124ShowExerciseStats-string": "Show exercise statistics to athletes: you can now turn exercise stats on or off. When disabled, athletes will no longer see exercise statistics (e1RM, tonnage, etc.) while training.",
  "v124ShowSetPriority-string": "Show set priority:  set priority is now optional. If you disable it, neither you nor your athletes will see set priorities.",
  "v124ToastNotification-string": "New in-app notifications",
  "v124ToastNotificationDesc-string": "Small on-screen messages now confirm key actions and show errors so you always know what just happened.",
  "v124PersonalizedOnboarding-string": "Personalized onboarding for new coaches",
  "v124PersonalizedOnboardingDesc-string": "New coaches now go through a short onboarding flow that asks a few key questions about how they work. Based on their answers, the app is pre-configured to better match their coaching style and needs.",
  "v124CustomizableSidebar-string": "Customizable sidebar",
  "v124CustomizableSidebarDesc-string": "You can now configure the sidebar to match your workflow: choose which sections of the app are visible and reorder them so the views you use most are always at the top. To customize it, hover over the sidebar and click the 'Configure sidebar' button.",
  "v124UpdatedLoginSignup-string": "Updated login and signup design",
  "v124UpdatedLoginSignupDesc-string": "We refreshed the login and signup screens with a cleaner layout and clearer copy, making it easier for new coaches to get started on any device.",

  "v123CoachAppStores-string": "Coach app on App Store and Play Store",
  "v123CoachAppStoresDesc1-string": "The coach app is now available on both the ",
  "v123CoachAppStoresAppStore-string": "App Store",
  "v123CoachAppStoresDesc2-string": " and ",
  "v123CoachAppStoresGooglePlay-string": "Google Play",
  "v123CoachAppStoresDesc3-string": ". From the app you can message your athletes, review lifts, make quick edits to their programs, and track their progress directly from your phone.",

  "v122NewTutorialsSite-string": "New tutorials site",
  "v122NewTutorialsSiteDesc-string": "We launched a tutorials website with short videos showing how to use the main parts of the app: Programs, Calendar, Library, Billing and Competitions. You can access it at any time from the Settings section.",

  "v121MarkChatsUnread-string": "Mark chats as unread",
  "v121MarkChatsUnreadDesc-string": "In any chat, you can now open the options menu and choose \"Mark as unread\". That chat will be highlighted again so you remember to come back to it later.",
  "v121NewVideoPlayer-string": "New video player in chat",
  "v121NewVideoPlayerDesc-string": "We replaced the video player inside chat with a new version to improve playback reliability and fix bugs that affected video review in previous versions.",

  "v120ExerciseLibrary-string": "Exercise library with custom videos and sorting",
  "v120ExerciseLibraryDesc-string": "The Library section now includes a dedicated Exercise Library view. From there you can reorder, create, and delete exercises, and attach your own custom video links to each exercise so they're always available when adding them to an athlete's program.",

  "v119NewCalendar-string": "New calendar with folders",
  "v119NewCalendarDesc-string": "The Calendar has been completely redesigned. You can now create folders directly from the calendar view and duplicate existing blocks just by dragging them.",

  "v118NewDashboard-string": "New dashboard view for block planning",
  "v118NewDashboardDesc-string": "Inside a program, there's a new dashboard tab that lets you edit the basic block information, define progression for the main lifts across the weeks, and adjust the weekly split of any block.",
  "v118SetIntervals-string": "Set intervals and short targets",
  "v118SetIntervalsDesc-string": "Programming fields now support intervals and short text targets in Weight, Reps and RPE/RIR. For example, you can use ranges like '10-12', 'max 220', 'min 210' or similar short formats instead of a single fixed value.",

  "v117ChatAndVideos-string": "Chat and videos",
  "v117ChatAndVideosDesc-string": "Athletes can now attach videos directly to specific sets. When they do, the app automatically posts a message in the chat with that set's video, so you can review it and send your feedback straight in the conversation.",

  "tagGeneral-string": "General",
  "tagCoachApp-string": "Coach app",
  "tagAthleteApp-string": "Athlete app",
  "tagChat-string": "Chat",
  "tagSettings-string": "Settings",
  "tagForms-string": "Forms",
  "tagApplications-string": "Applications",
  "tagStatistics-string": "Statistics",
  "tagCompetitions-string": "Competitions",
  "tagProgram-string": "Program",
  "tagModifiersLibrary-string": "Modifiers library",
  "tagCalendar-string": "Calendar",
  "tagAthleteOverview-string": "Athlete overview",
  "tagAthleteProfile-string": "Athlete profile",
  "tagWorkoutLibrary-string": "Workout library",
  "tagExerciseLibrary-string": "Exercise library",
  "tagBlock-string": "Block",
  "tagBlockLibrary-string": "Block library",

  "monthJan-string": "Jan",
  "monthFeb-string": "Feb",
  "monthMar-string": "Mar",
  "monthApr-string": "Apr",
  "monthMay-string": "May",
  "monthJun-string": "Jun",
  "monthJul-string": "Jul",
  "monthAug-string": "Aug",
  "monthSep-string": "Sep",
  "monthOct-string": "Oct",
  "monthNov-string": "Nov",
  "monthDec-string": "Dec",

  "TITOL NOTIFICACIONS TOAST": "",

  "clientSyncErrorTransaction-string": "Error uploading athlete data",
  "clientSyncErrorTransactionDescription-string": "We couldn't save changes for {{clientEmail}}. Click the ! icon to try again. If it keeps happening, contact support.",
  "clientSyncErrorBlocks-string": "Error fetching blocks",
  "clientSyncErrorBlocksDescription-string": "We couldn't load blocks for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "clientSyncErrorCompetition-string": "Error fetching competition",
  "clientSyncErrorCompetitionDescription-string": "We couldn't load competition data for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "clientSyncErrorForms-string": "Error fetching forms",
  "clientSyncErrorFormsDescription-string": "We couldn't load forms for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "clientSyncErrorChat-string": "Error loading chat",
  "clientSyncErrorChatDescription-string": "We couldn't load the chat for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "clientSyncErrorArrays-string": "Error fetching athlete data",
  "clientSyncErrorArraysDescription-string": "We couldn't load the athlete's notes, bodyweights, and tracs for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "clientSyncErrorNutritionPlans-string": "Error fetching nutrition plans",
  "clientSyncErrorNutritionPlansDescription-string": "We couldn't load nutrition plans for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "clientSyncError-string": "Sync error",
  "clientSyncErrorGenericDescription-string": "We couldn't sync data for {{clientEmail}}. Click the ! icon or reload the page. If it keeps happening, contact support.",

  "syncErrorTransaction-string": "Error uploading coach data",
  "syncErrorTransactionDescription-string": "We couldn't save your data. Click the ! icon to try again. If it keeps happening, contact support.",
  "syncErrorClients-string": "Error fetching athletes",
  "syncErrorClientsDescription-string": "We couldn't load your athletes. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorInvitations-string": "Error fetching invitations",
  "syncErrorInvitationsDescription-string": "We couldn't load your invitations. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorChats-string": "Error loading chats",
  "syncErrorChatsDescription-string": "We couldn't load your chats. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorCoachData-string": "Error fetching coach data",
  "syncErrorCoachDataDescription-string": "We couldn't load your coach data. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorCoachProfile-string": "Error fetching coach settings",
  "syncErrorCoachProfileDescription-string": "We couldn't load your settings. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorForms-string": "Error fetching forms",
  "syncErrorFormsDescription-string": "We couldn't load your forms. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorCompetitions-string": "Error fetching competitions",
  "syncErrorCompetitionsDescription-string": "We couldn't load your competitions. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorBlockLibrary-string": "Error fetching block library",
  "syncErrorBlockLibraryDescription-string": "We couldn't load your block library. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorWorkoutLibrary-string": "Error fetching workout library",
  "syncErrorWorkoutLibraryDescription-string": "We couldn't load your workout library. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorFoodLibrary-string": "Error fetching food library",
  "syncErrorFoodLibraryDescription-string": "We couldn't load your food library. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorNutritionPlans-string": "Error fetching nutrition plans",
  "syncErrorNutritionPlansDescription-string": "We couldn't load your nutrition plans. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorApplicationForm-string": "Error fetching application form",
  "syncErrorApplicationFormDescription-string": "We couldn't load your application form. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorApplications-string": "Error fetching applications",
  "syncErrorApplicationsDescription-string": "We couldn't load your applications. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorSubscription-string": "Error fetching subscription",
  "syncErrorSubscriptionDescription-string": "We couldn't load your subscription details. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncErrorLogo-string": "Error fetching logo",
  "syncErrorLogoDescription-string": "We couldn't load your logo. Click the ! icon or reload the page. If it keeps happening, contact support.",
  "syncError-string": "Sync error",
  "syncErrorGenericDescription-string": "We couldn't sync your data. Click the ! icon or reload the page. If it keeps happening, contact support.",

  "invitationSent-string": "Invitation sent",
  "invitationSentDescription-string": "Successfully sent 1 invitation.",
  "blockCopiedInCalendar-string": "Block copied in calendar",
  "blockCopiedInCalendarDescription-string": "The block '{{blockName}}' has been copied.",
  "blockCopied-string": "Block copied",
  "blockCopiedDescription-string": "The block '{{blockName}}' has been copied.",
  "blockCopiedToClient-string": "Block copied to athlete",
  "blockCopiedToClientDescription-string": "The block '{{blockName}}' has been copied to {{clientName}}.",
  "step1Completed-string": "Step 1 completed",
  "step1CompletedDescription-string": "Congratulations! You've completed the second step of the getting started guide.",
  "step2Completed-string": "First exercise added",
  "step2CompletedDescription-string": "Nice! You added your first exercise to a workout.",
  "step3Completed-string": "Step 3 completed",
  "step3CompletedDescription-string": "Congratulations! You've invited your first athlete.",
  "workoutExportedToLibrary-string": "Workout exported to library",
  "workoutExportedToLibraryDescription-string": "The workout '{{workoutName}}' is now saved in your workout library.",
  "blockExportedToLibrary-string": "Block exported to library",
  "blockExportedToLibraryDescription-string": "The block '{{blockName}}' is now saved in your block library.",
  "invitationEmailError-string": "Invitation not delivered",
  "invitationEmailErrorDescription-string": "The invitation we tried to send to {{clientEmail}} couldn't be delivered. Check the email is correct and try again.",
  "connectionLost-string": "You're offline",
  "connectionLostDescription-string": "Your internet connection was lost. Changes will be saved locally and synced when you're back online.",
  "connectionRestored-string": "You're back online",
  "connectionRestoredDescription-string": "Your internet connection has been restored. We're syncing your changes now. Please don't close this window until everything is uploaded.",
  "offlineViewTitle-string": "You're offline",
  "offlineViewDescription-string": "Please check your internet connection and try again",

  "TITOL SIDE MENU": "",

  "home-string": "Home",
  "settings-string": "Settings",
  "configureSidebar-string": "Configure sidebar",
  "customizeNavigation-string": "Customize your navigation",
  "customizeNavigationDescription-string": "Mark the categories you want to see and drag them to change the order.",

  "athletes-string": "Athletes",
  "searchClient-string": "Search Athletes",
  "withoutActiveBlock-string": "No active block",
  "clientWeekStatus-string": "Week: {{blockCurrentWeek}} / {{blockWeeks}}",
  "startingWeekOf-string": "Starting the week of {{date}}",
  "notSet-string": "Not set",
  "clientWeekStatusPrepared-string": "Week: {{blockCurrentWeek}} / {{blockWeeks}}",
  "clientWeekStatusUnprepared-string": "Week: <red>{{blockCurrentWeek}}</red> / {{blockWeeks}}",

  "pendingClients-string": "Pending Athletes",
  "completedClients-string": "Completed Athletes",
  "clientsWithBlockToCreate-string": "Athletes Pending New Block",
  "clientsWithWeekToUpdate-string": "Athletes Pending Block Update",
  "startsWeekIn-string": "Starts week on:",
  "endsWeekIn-string": "Ends week on:",

  "freeTrialDayLeft-string": "You have {{daysLeft}} day left in your trial.",
  "freeTrialDaysLeft-string": "You have {{daysLeft}} days left in your trial.",
  "youHaveMaxClients-string": "You have {{clientsLength}} athletes!",
  "useUpgradeDiscount-string": "Use the code 'UpgradePlan' and get a 30% discount for 1 month when you upgrade your plan.",

  "TITOL STRIPE": "",

  "manageSubscription-string": "Manage Subscription",
  "reachedMaxClientsStripeView-string": "You have reached the athlete limit for your subscription.\n\nTo add more, click 'Manage Subscription' to easily upgrade.",
  "stripeBottomText1-string": "You can cancel your monthly subscription at any time before the billing period ends.",
  "stripeBottomText2-string": "Your subscription will automatically renew every month.",
  "upTo5Athletes-string": "Up to 5 athletes",
  "upTo15Athletes-string": "Up to 15 athletes",
  "upTo30Athletes-string": "Up to 30 athletes",
  "upTo50Athletes-string": "Up to 50 athletes",
  "moreThan50Athletes-string": "More than 50 athletes",
  "priceWithCurrency-string": "${{price}}",
  "pricePerMonth-string": "${{price}} / month",
  "pricePerAthlete-string": "${{price}} / athlete",
  "pricePerMonthDiscount-string": "/ month",
  "stripePaymentFailedProblemText-string": "There was a problem with the subscription renewal",
  "stripePaymentFailedActiveSub-string": "Please complete the payment to keep your subscription active.",
  "stripePaymentFailedNewSub-string": "Please complete the payment to activate your subscription.",
  "stripePaymentFailedDoPayment-string": "Make the payment",
  "stripePaymentFailedAuxText-string": "Or go to your ",
  "stripePaymentFailedAccountConfig-string": "account settings",

  "TITOL COACH DASHBOARD": "",

  "helloCoach-string": "Hello, {{coachName}}",

  "deleteAthleteAlertTitle-string": "DELETE ATHLETE",
  "deleteAthleteAlertText-string": "Are you sure you want to delete the athlete?",

  "dashboardBlockToCreateTooltip-string": "Athletes in the last week of their block",
  "dashboardWeekToUpdateTooltip-string": "Athletes in the middle of their block",

  "nextCompetitions-string": "Next Competitions",
  "emptyCompetitionsTitle-string": "No Upcoming Competitions",
  "emptyCompetitionsText-string": "Go to the competitions section to create new ones",
  "noAthletesInCompetitionText-string": "There are currently no athletes assigned to this competition.",

  "clientHeader-string": "ATHLETE",
  "competitorHeader-string": "COMPETITOR",
  "weekHeader-string": "WEEK",
  "workoutsOfWeekHeader-string": "TRAINING DAYS",
  "workoutsOfWeekTooltip-string": "Mark which days each athlete trains. Use this section to quickly find athletes who train on a given day.",
  "statusHeader-string": "STATUS",
  "monHeader-string": "Mon",
  "tueHeader-string": "Tue",
  "wedHeader-string": "Wed",
  "thuHeader-string": "Thu",
  "friHeader-string": "Fri",
  "satHeader-string": "Sat",
  "sunHeader-string": "Sun",
  "active-string": "Active",
  "pending-string": "Pending",
  "error-string": "Error",
  "invitationErrorTooltip-string": "There was an error delivering the invitation, please check the email is correct, delete this invitation and try again.",
  "invitationPendingTooltip-string": "An email has been sent to this athlete. They need to download the Efort app and accept your invitation.",
  "noResultsFound-string": "No results found",
  "noResultsFoundDescription-string": "We couldn't find any athletes matching your search. Try adjusting your search terms.",

  "TITOL CONVIDAR ATLETES": "",
  "addClient-string": "Add Athlete",
  "addClientText-string": "Athletes will be guided to download the Efort app.",
  "emailAlreadyInUseText-string": "The athlete is already invited",
  "userAlreadyHasCoachText-string": "The athlete already has a coach",
  "errorSendingEmailText-string": "The email does not exist",
  "emailSentText-string": "Invitation sent!",
  "emailPlaceholder-string": "athlete@gmail.com",
  "send-string": "Send",
  "toDownloadGuide-string": "to download the athlete user guide.",
  "clickHere-string": "Click here",
  "inviteAthlete-string": "Invite Athletes",
  "inviteAthleteSubtitle-string": "Send invitations for athletes to join you on Efort Coach. They'll receive an email guiding them to download the Efort app and accept your invitation.",
  "previewAthleteApp-string": "Preview athlete app",
  "athleteUserGuide-string": "Athlete user guide (PDF)",
  "athleteEmailAddresses-string": "Athlete email addresses",
  "typeEmailHint-string": "Type an email and press Enter to add more",
  "invalidEmailFormat-string": "Invalid email format",
  "sendInvitations-string": "Send invitations",
  "alreadyInvited-string": "Already invited",
  "alreadyHasCoach-string": "Already has a coach",
  "invitationsSent-string": "Invitations sent",
  "invitationsSentDescription-string": "Successfully sent {{count}} invitations.",
  "errorSendingInvitations-string": "Error sending invitations",

  "TITOL COACH LIBRARY": "",

  "library-string": "Library",
  "workouts-string": "Workouts",
  "forms-string": "Forms",
  "searchWorkout-string": "Search Workouts",
  "searchBlock-string": "Search Blocks",

  "newWorkout-string": "New Workout",
  "newWorkoutCount-string": "New Workout ({{count}})",
  "changeWorkoutNameTitle-string": "Change the name of the workout",
  "createWorkoutTitle-string": "Create a new workout",

  "exerciseCountOne-string": "{{count}} Exercise",
  "exerciseCount-string": "{{count}} Exercises",
  "firstExercise-string": "First exercise",
  "secondExercise-string": "Second exercise",

  "emptyWorkoutsTitle-string": "No Workouts",
  "createTemplateWorkoutsText-string": "Add new template workouts",

  "emptyBlocksTitle-string": "No Blocks",
  "createTemplateBlocksText-string": "Add new template blocks",

  "workoutCountOne-string": "{{count}} Workout",
  "workoutCount-string": "{{count}} Workouts",

  "deleteWorkoutAlertTitle-string": "DELETE WORKOUT",
  "deleteWorkoutAlertText-string": "Are you sure you want to delete the workout from the library?",

  "notes-string": "Notes",
  "privateNotePlaceholder-string": "Private note...",
  "searchAttributes-string": "Search Modifiers",
  "searchExercise-string": "Search Exercises",
  "selectExercise-string": "Select an exercise",
  "selectManually-string": "Select exercise manually",
  "deleteExercise-string": "Delete exercise",
  "recentlyUsed-string": "Recently used",
  "suggestions-string": "Suggestions",
  "navigate-string": "Navigate",
  "notFindingWhatYouWant-string": "Can't find what you're looking for?",
  "selectExerciseManually-string": "Select exercise manually",

  "searchForm-string": "Search Forms",
  "newForm-string": "New Form",
  "initialForm-string": "Initial form",
  "weeklyForms-string": "Weekly forms",
  "blockForms-string": "Block forms",
  "default-string": "Default",
  "questionCountOne-string": "{{count}} Question",
  "questionCount-string": "{{count}} Questions",
  "set-string": "Set",
  "setAsDefault-string": "Set as default for new athletes",

  "withoutWeeklyForms-string": "No Weekly Forms",
  "createWeeklyForms-string": "Create forms that your athletes will automatically receive each week",
  "withoutBlockForms-string": "No Block Forms",
  "createBlockForms-string": "Create forms that your athletes will automatically receive at the end of each training block",

  "selectAll-string": "Select all",
  "unselectAll-string": "Unselect all",
  "editForm-string": "Edit Form",
  "deleteForm-string": "Delete form",
  "createForm-string": "Add a new form",
  "initialFormText1-string": "Athletes fill out the initial form when they accept your invitation.",
  "initialFormText2-string": "In addition to your questions, fields for first name, last name, and gender will be included.",
  "initialFormType-string": "Initial",
  "weeklyFormType-string": "Weekly",
  "blockFormType-string": "End of Block",
  "emptyClientsTitle-string": "No Athletes",
  "addNewClientsText-string": "Add new athletes",
  "noAthletesFoundText-string": "No athletes found",
  "addQuestion-string": "Add question",
  "addSection-string": "Add Section",
  "nameOfSection-string": "Section name",
  "deleteSection-string": "Delete Section",
  "questionPlaceholderText-string": "Type the question and choose the answer type",
  "questionTextType-string": "Text",
  "questionNumberType-string": "Number (1-5)",

  "deleteFormAlertTitle-string": "DELETE FORM",
  "deleteFormAlertText-string": "Are you sure you want to delete the form from the library?",
  "setDefaultFormAlertTitle-string": "SET AS DEFAULT",
  "setDefaultFormAlertText-string": "Are you sure you want to set this form as default?\n\nThis form will be applied to all new athletes.",

  "mondayLetter-string": "M",
  "tuesdayLetter-string": "T",
  "wednesdayLetter-string": "W",
  "thursdayLetter-string": "T",
  "fridayLetter-string": "F",
  "saturdayLetter-string": "S",
  "sundayLetter-string": "S",

  "TITOL FACTURACIO": "",

  "billing-string": "Billing",

  "beginningOfQuotaHeader-string": "START DATE",
  "feeHeader-string": "FEE",
  "quotaTypeHeader-string": "PAYMENT TYPE",
  "endOfQuotaHeader-string": "END DATE",
  "toPayHeader-string": "AMOUNT DUE",
  "actionsHeader-string": "ACTIONS",

  "totalToCollect-string": "TOTAL AMOUNT DUE:",
  "feeWithCurrency-string": "${{fee}}",
  "renewPlan-string": "Renew plan",
  "viewHistory-string": "View history",
  "hideHistory-string": "Hide history",
  "copyTargetSets-string": "Copy programmed sets",
  "owedQuotasRow-string": "${{amount}} ({{quotas}} payments)",

  "monthly-string": "Monthly",
  "quarterly-string": "Quarterly",
  "semestral-string": "Semiannual",
  "yearly-string": "Yearly",
  "Mensual": "Monthly",
  "Trimestral": "Quarterly",
  "Semestral": "Semiannual",
  "Anual": "Yearly",

  "renew-string": "Renew",
  "nextPaymentWillBe-string": "Next payment will be: {{newDay}} / {{endMonthReturn}} / {{endYearReturn}}",
  "renewClientsQuota-string": "Renew {{name}}'s payment",
  "feeDots-string": "Fee:",
  "quotaTypeDots-string": "Payment type:",
  "beginningOfQuotaDots-string": "Start date:",
  "feeIsVoid-string": "The payment must include a fee.",

  "quotaHistoryOfClient-string": "Payment history of {{name}}",

  "TITOL COMPETICIONS": "",

  "competitions-string": "Competitions",
  "searchCompetition-string": "Search Competitions",
  "newCompetition-string": "New Competition",
  "emptyCompetitionsLibraryTitle-string": "No Competitions",
  "emptyCompetitionsLibraryText-string": "Add competitions and plan the attempts of your athletes",

  "deleteCompetitionAlertTitle-string": "DELETE COMPETITION",
  "deleteCompetitionAlertText-string": "Are you sure you want to delete the competition?",

  "alreadyHappened-string": "Already happened",
  "isToday-string": "It's today",
  "isTodayName-string": "{{name}} is today",
  "isThisWeek-string": "It's this week",
  "isThisWeekName-string": "{{name}} is this week",
  "oneWeekLeft-string": "1 week left",
  "oneWeekLeftName-string": "1 week left for {{name}}",
  "someWeeksLeft-string": "{{weeks}} weeks left",
  "someWeeksLeftName-string": "{{weeks}} weeks left for {{name}}",
  "totalValidAttempts-string": "{{totalValidAttempts}}/{{totalAttempts}} attempts",
  "totalValidThirdAttempts-string": "{{totalValidAttempts}}/{{totalAttempts}} third attempts",
  "men-string": "Men",
  "women-string": "Women",

  "nameOfCompetition-string": "Competition name",
  "category-string": "Category",
  "level-string": "Level",
  "competitionFederationChangeAlertTitle-string": "CHANGE FEDERATION",
  "competitionFederationChangeAlertText-string": "Changing federation will remap athlete weight classes to the closest valid class. You can adjust them later.",
  "competitionFederationRemapToastTitle-string": "Weight classes updated",
  "competitionFederationRemapToastDescription-string": "Updated {{count}} athlete categories after federation change.",
  "emptyCategoryTitle-string": "No Weight Class",
  "emptyCategoryText-string": "Select a weight class to add your athletes to the competition",

  "competitionTime-string": "Competition time",
  "weightInTime-string": "Weight in time",
  "firstTry-string": "1st Att",
  "secondTry-string": "2nd Att",
  "thirdTry-string": "3rd Att",
  "warmups-string": "Warm-ups",
  "minimumTotal-string": "Minimum total",
  "goodTotal-string": "Good total",
  "mediumTotal-string": "Medium total",
  "badTotal-string": "Bad total",
  "difference-string": "Difference",
  "competitionNotes-string": "Competition notes",
  "firstGoal-string": "First goal of the competition",
  "secondGoal-string": "Second goal of the competition",
  "thirdGoal-string": "Third goal of the competition",
  "competitionRecap-string": "Competition results",
  "competitionTotal-string": "Competition total:",
  "competitionRecapNotes-string": "Notes on the competition results",

  "TITOL AJUSTES": "",

  "profile-string": "Profile",
  "name-string": "Name",
  "surname-string": "Surname",
  "email-string": "Email",
  "preferences-string": "Preferences",
  "exerciseUnit-string": "Exercise Unit",
  "language-string": "Language",
  "resetPredefinedExercises-string": "Reset predefined exercises",
  "resetPredefinedAttributes-string": "Reset predefined modifiers",
  "offline-string": "Offline Mode",
  "downloadAllAthletes-string": "Download all athletes",
  "downloadAllAthletesToMakeAvailable-string": "Download all athletes' data to make them available offline.",
  "download-string": "Download",
  "account-string": "Account",
  "logOut-string": "Log Out",
  "deleteAccount-string": "Delete Account",
  "subscription-string": "Subscription",
  "resetButton-string": "Reset",
  "yourLogo-string": "Your logo",
  "uploadYourLogo-string": "Click here to\nupload your logo",
  "support-string": "Support",
  "learnAndUpdates-string": "Learn and Updates",
  "reportProblem-string": "Report a problem",
  "reportProblemText-string": "Need help? Message us on Instagram at @efortapp",
  "sendFeedbackSettings-string": "Send feedback",
  "contactUs-string": "Contact us",

  "resetExercisesAlertTitle-string": "RESET PREDEFINED EXERCISES",
  "resetExercisesAlertText-string": "Are you sure you want to reset the predefined exercises?\n\nThe ones you created will not be deleted.",
  "resetAttributesAlertTitle-string": "RESET PREDEFINED MODIFIERS",
  "resetAttributesAlertText-string": "Are you sure you want to reset the predefined modifiers?\n\nThe ones you created will not be deleted.",
  "deleteAccountAlertTitle-string": "DELETE ACCOUNT",
  "deleteAccountAlertText-string": "Are you sure you want to delete your account?\n\nYou will lose all the information you have.",
  "changeLanguageAlertTitle-string": "CHANGE EXERCISE LANGUAGE",
  "changeLanguageAlertText-string": "Changing the language of the exercises may take a few minutes and could interrupt athletes using the app. Do you want to continue?",
  "deleteLogoAlertTitle-string": "DELETE LOGO",
  "deleteLogoAlertText-string": "Are you sure you want to delete your logo?",
  "uploadFailedText-string": "Upload failed. Please try again.\n",
  "selectImageFileText-string": "Please select an image file.\n",
  "imageSizeLimitText-string": "The selected image exceeds the 5MB size limit. Please select a smaller image.\n",
  "uploadErrorTitle-string": "ERROR DURING UPLOAD\n",
  "preferenceDefaultBlockView-string": "Default block view",
  "preferenceDefaultBlockViewTooltip-string": "Choose which view opens first when you open a block: Workouts or Dashboard.",

  "TITOL INSCRIPCIONS": "",

  "applications-string": "Applications",
  "required-string": "Required",
  "notRequired-string": "Not required",
  "requiredInfo-string": "Required information",
  "directoryTaken-string": "Link is already taken. Try another one.",
  "yourAnswer-string": "Your answer",
  "submit-string": "Submit",
  "clear-string": "Clear",
  "clearFormAlertTitle-string": "CLEAR FORM",
  "clearFormAlertText-string": "This will remove your answers from all questions, and cannot be undone.",
  "applicationSentTitle-string": "APPLICATION SENT",
  "applicationSentText-string": "Your application has been successfully sent to {{coachName}}. They will review it and get back to you soon.",
  "nameDots-string": "Name: ",
  "surnameDots-string": "Surname: ",
  "emailDots-string": "Email: ",
  "deleteApplicationAlertTitle-string": "DELETE APPLICATION",
  "deleteApplicationAlertText-string": "Are you sure you want to delete the coaching application?",
  "deleteCoachApplicationAlertTitle-string": "DELETE APPLICATION FORM",
  "deleteCoachApplicationAlertText-string": "Are you sure you want to delete the application form?",
  "ApplicationStep1-string": "Enter the link where athletes will be directed to complete the form",
  "ApplicationStep2-string": "Edit the form and add your questions",
  "ApplicationStep3-string": "Copy the link and share it!",
  "followTheseSteps-string": "Follow these steps to start receiving coaching applications",
  "registrationForm-string": "Coaching Form",
  "noNewApplications-string": "There aren't any new applications to review",
  "whenNewApplication-string": "When someone fills out your coaching form, you'll receive it here",
  "questionPlaceholderFormApplicationsText-string": "Type your question and choose if it's a required field",
  "requiredFieldsNotFilled-string": "Please answer all required questions",
  "yourBrand-string": "your-brand",

  "TITOL CLIENT DASHBOARD": "",

  "currentBlock-string": "BLOCK",
  "noScheduledWorkouts-string": "No scheduled workouts for this week",
  "weekOfTotal-string": "Week",
  "of-string": "of",
  "weeksPendingToCreate-string": "weeks pending to create",
  "weekPendingToCreate-string": "week pending to create",
  "oneWeekPlanned-string": "1 week planned",
  "weeksPlanned-string": "{{count}} weeks planned",
  "weeksPlannedOf-string": "{{created}} / {{total}} weeks planned",
  "nextCompetition-string": "NEXT COMPETITION",
  "thisWeek-string": "This week",
  "oneWeekOut-string": "1 week out",
  "weeksOut-string": "weeks out",
  "workoutsTitle-string": "WORKOUTS",
  "week-string": "Week",
  "notesTitle-string": "NOTES",
  "privateNote-string": "PRIVATE NOTE",
  "privateNoteInfo-string": "Use the private note for athlete annotations or reminders. This note persists across weeks and blocks.",
  "onlyVisibleToYou-string": "Only visible to you...",
  "dailyNotes-string": "DAILY NOTES",
  "dailyNotesInfo-string": "Daily notes will appear in the athlete's app on the home page and in the corresponding day in the calendar",
  "addExercisesBeforeCreatingWeek-string": "Add exercises to all workouts in the week before creating a new week.",
  "createWorkoutsBeforeAddingToCalendar-string": "Create all workouts for the week before adding them to the calendar.",
  "noteForDay-string": "Note for {{day}}...",
  "chatTitle-string": "CHAT",
  "messagesSection-string": "Messages",
  "new-string": "new",
  "videosSection-string": "Videos",
  "moreMessages-string": "+{{count}} more messages",
  "moreVideos-string": "+{{count}} more videos",
  "formsTitle-string": "FORMS",
  "blockForm-string": "Block form",
  "weeklyForm-string": "Weekly form",
  "review-string": "Review",
  "completed-string": "Completed",
  "notCompleted-string": "Not completed",
  "notSent-string": "Not sent",
  "bodyweightTitle-string": "BODYWEIGHT",
  "weeklyAverage-string": "Weekly Average",
  "vsPriorWeek-string": "vs. prior week",
  "lastWeeklyAverage-string": "Last Weekly Average",
  "weekOf-string": "week of",
  "noDataYet-string": "No data yet",
  "bodyweightTrendsInfo-string": "Bodyweight trends will appear here once the athlete starts logging it",
  "tracTrendsInfo-string": "Trac trends will appear here once the athlete logs it",
  "hideNote-string": "Hide Note",
  "soreness-string": "Soreness",
  "recoveryContext-string": "Recovery & Context",

  "legSoreness-string": "Leg Soreness",
  "pushSoreness-string": "Push Soreness",
  "pullSoreness-string": "Pull Soreness",
  "perceivedRecovery-string": "Perceived Recovery",
  "motivation-string": "Motivation",
  "technicalComfort-string": "Technical Comfort",
  "sleepQualityNutrition-string": "Sleep/Nutrition",

  "soreness1-string": "Severe soreness, very uncomfortable",
  "soreness2-string": "Significant soreness, uncomfortable",
  "soreness3-string": "Moderate soreness, noticeable but manageable",
  "soreness4-string": "Mild soreness, barely noticeable",
  "soreness5-string": "No soreness or stiffness",

  "perceivedRecovery1-string": "Completely exhausted",
  "perceivedRecovery2-string": "Very tired",
  "perceivedRecovery3-string": "Somewhat tired",
  "perceivedRecovery4-string": "Moderately fresh",
  "perceivedRecovery5-string": "Very fresh",

  "motivation1-string": "No motivation",
  "motivation2-string": "Slightly motivated",
  "motivation3-string": "Somewhat motivated",
  "motivation4-string": "Moderately motivated",
  "motivation5-string": "Very motivated",

  "sleepQuality1-string": "Poor nutrition and rest",
  "sleepQuality2-string": "Regular nutrition or rest",
  "sleepQuality3-string": "Acceptable nutrition and rest",
  "sleepQuality4-string": "Good nutrition and rest",
  "sleepQuality5-string": "Optimal nutrition and rest",

  "technicalComfort1-string": "Very uncomfortable technically",
  "technicalComfort2-string": "A little uncomfortable technically",
  "technicalComfort3-string": "Somewhat comfortable technically",
  "technicalComfort4-string": "Mostly comfortable technically",
  "technicalComfort5-string": "Very comfortable technically",

  "summary-string": "Overview",
  "addNote-string": "Add Note",
  "deleteNote-string": "Delete Note",
  "noData-string": "No data",
  "bodyweight-string": "Bodyweight",
  "exerciseQuestionMarkText-string": "You can choose the exercises in the block dashboard",
  "wOfExercise-string": "W{{week}}",
  "competition-string": "Competition",
  "note-string": "Note",
  "workout-string": "Workout",
  "weekOfWorkout-string": "Week: {{week}}",
  "noExercisesYet-string": "No exercises yet",
  "addOneOrPasteFromClipboard-string": "Add one or paste from clipboard",
  "selectExercisePlaceholder-string": "Select...",
  "editWorkoutName-string": "Edit workout name",
  "copyWorkoutExercises-string": "Copy workout exercises",
  "moveWorkoutUp-string": "Move workout up",
  "moveWorkoutDown-string": "Move workout down",
  "deleteWorkoutTooltip-string": "Delete workout",
  "deleteWorkoutFromCalendar-string": "Delete from calendar",
  "deleteWorkoutFromCalendarAlertText-string": "Are you sure you want to delete the workout from the calendar?",
  "pasteExercise-string": "Paste exercise",
  "pasteExercises-string": "Paste exercises",
  "moreOptions-string": "More options",
  "todayBodyweight-string": "Today: {{bodyweight}}",
  "todayTrac-string": "Today: {{count}}/20",

  "calendar-string": "Calendar",
  "january-string": "January",
  "february-string": "February",
  "march-string": "March",
  "april-string": "April",
  "may-string": "May",
  "june-string": "June",
  "july-string": "July",
  "august-string": "August",
  "september-string": "September",
  "october-string": "October",
  "november-string": "November",
  "december-string": "December",
  "block-string": "BLOCK",
  "weeks-string": "WEEKS",
  "startDate-string": "START DATE",
  "endDate-string": "END DATE",
  "willStartWeekOf-string": "Will start the week of {{date}}",
  "thereIsABlockAlready-string": "There is already a block on the calendar during those weeks",
  "haveToAddNameToBlock-string": "You have to add a name to the block",
  "weeksDots-string": "Weeks:",
  "label-string": "Folder",
  "labelEmptyText-string": "There are no folders with that name. A new one will be created when you press save.",
  "splitInfoText-string": "The displayed split is based on first week's workout dates",
  "noSlotsForWeek-string": "Week {{week}} does not have any slots yet. Create new slots below.",
  "dontWantMoreSlots-string": "Done adding slots?",
  "goToWorkoutsAddAccessories-string": "Go to Workouts to add accessory exercises",

  "hideBlocksWithoutDate-string": "Hide blocks without date",
  "showBlocksWithoutDate-string": "Show blocks without date",
  "noBlocksThisYear-string": "No Blocks For This Year",
  "dragToCreateBlock-string": "Drag between two dates to create a block for the chosen weeks",
  "cantMoveBlockWithDatedWorkouts-string": "It's not possible to move a block that already has dated workouts",
  "blockWithoutDate-string": "Blocks Without Date",
  "calendarBlocksUpdateInfo-string": "Blocks created from the calendar will now also appear here.",
  "planBlocksSequence-string": "Create training blocks in the calendar by dragging between two dates. Then open each block from the Program section.",

  "addVideoLinkMenu-string": "Add video link",
  "editVideoLinkMenu-string": "Edit video link",
  "duplicateExerciseMenu-string": "Duplicate",
  "linkExerciseToSlotMenu-string": "Link exercise to slot",
  "unlinkExerciseFromSlotMenu-string": "Unlink exercise from slot",
  "linkSlotInfo-string": "By linking an exercise to a slot you will be able to work with that exercise from the block dashboard.",
  "addWorkout-string": "Add workout",

  "emptyBlocksInMacroTitle-string": "Select a Block",
  "emptyBlocksInMacroText-string": "Select a block to show its slots and protocols here",

  "actualWithDataCopyCalendarBlockTitle-string": "UNABLE TO COPY BLOCK",
  "actualWithDataCopyCalendarBlockText-string": "The block '{{blockName}}' already has sets with data. Please delete the sets before copying the block.",

  "copyCalendarBlockWarningTitle-string": "COPY BLOCK",
  "copyCalendarBlockWarningText-string": "Replace all workouts and slots in '{{targetBlockName}}' with those from '{{sourceBlockName}}'?",
  "copyCalendarBlockDoubleConfirmationText-string": "Overwrite all existing workouts.",

  "dropCalendarBlockToCopyTitle-string": "Drop Here to Copy Block",
  "dropCalendarBlockToCopyText-string": "Drop the block here to copy its workouts and slots to the target block",

  "withoutForms-string": "No Forms",
  "addFormsFromLibrary-string": "Add forms to the athlete from the library.",
  "weekly-string": "Weekly",
  "endOfBlock-string": "End of Block",
  "answersCountOne-string": "{{count}} Answer",
  "answersCount-string": "{{count}} Answers",

  "stats-string": "Statistics",
  "blocks-string": "Blocks",
  "unlabeledFolder-string": "No folder",
  "exercises-string": "Exercises",
  "startDots-string": "Start:",
  "endDots-string": "End:",
  "weekWithNumber-string": "Week {{week}}",
  "addExercise-string": "Add exercise",

  "e1rm-string": "Estimated 1RM",
  "tonnage-string": "Tonnage",
  "intensityPercentage-string": "Intensity Percentage",
  "numberOfLifts-string": "Number of Lifts",
  "numberOfSets-string": "Number of Sets",
  "stressIndex-string": "Stress Index",
  "statsMetricE1RMTooltip-string": "Highest estimated 1RM from any logged set.",
  "statsMetricStressIndexTooltip-string": "Total Stress Index across all sets (sum of per-set stress derived from RPE).",
  "statsMetricTonnageTooltip-string": "Total tonnage (weight × reps) summed across all sets.",
  "statsMetricIntensityPctTooltip-string": "Average how heavy the sets were, shown as % of your estimated 1RM.",
  "statsMetricNumberOfLiftsTooltip-string": "Total repetitions performed (all sets combined).",
  "statsMetricNumberOfSetsTooltip-string": "Total sets performed.",
  "statsMetricExertionLoadTooltip-string": "Total Exertion Load (XL) across the selection, combining reps and RPE/RIR to estimate effort.",

  "statisticsChartNoDataInfo-string": "Select an exercise to see the chart.",
  "statisticsRangeLabel-string": "Range:",
  "statisticsStartLabel-string": "Start:",
  "statisticsEndLabel-string": "End:",
  "statisticsPresetLast3Months-string": "Last 3 Months",
  "statisticsPresetLast6Months-string": "Last 6 Months",
  "statisticsPresetYearToDate-string": "Year to Date",
  "statisticsPresetAllTime-string": "All Time",
  "statisticsPresetSelectRange-string": "Select Range",
  "statisticsWeekNumber-string": "Week {{week}}",
  "statisticsHiddenBlocks-string_one": "{{count}} hidden",
  "statisticsHiddenBlocks-string_other": "{{count}} hidden",
  "statisticsMaxSelectionReached-string": "Max {{count}} reached",
  "statisticsBlocksTitle-string": "Blocks",
  "statisticsExercisesTitle-string": "Exercises",
  "statisticsAddExerciseTooltip-string": "Add an exercise",
  "statisticsUnselectToAdd-string": "Unselect exercises to add a new one",
  "statisticsAllSlots-string": "All slots",
  "statisticsHelperSelectBlockOrExercises-string": "Select a block or add exercises to begin",
  "statisticsHelperAnalyzingSingleAcrossTime-string": "Analyzing {{exercise}} across time",
  "statisticsHelperComparingExercisesAcrossTime-string": "Comparing {{count}} exercises across time",
  "statisticsHelperSelectOneExercise-string": "Select one exercise to analyze",
  "statisticsHelperAnalyzingInBlock-string": "Analyzing {{exercise}} in {{block}}",
  "statisticsHelperComparingExercisesInBlock-string": "Comparing {{count}} exercises in {{block}}",
  "statisticsHelperSelectExerciseToCompare-string": "Select an exercise to compare",
  "statisticsHelperComparingExerciseAcrossBlocks-string": "Comparing {{exercise}} across {{blockCount}} blocks",
  "statisticsHelperComparingExercisesAcrossBlocks-string": "Comparing exercises across {{blockCount}} blocks",
  "statisticsHelperSelectData-string": "Select data to analyze",
  "statisticsFallbackBlockName-string": "Block",
  "statisticsFallbackExerciseName-string": "Exercise",
  "statisticsMetricNone-string": "None",

  "statisticsProtocolSlotNotSharedTooltip-string": "Not all selected blocks contain this slot",
  "tooltipHiddenEntry-string": "+{{count}} entry",
  "tooltipHiddenEntries-string": "+{{count}} entries",

  "dateHeader-string": "DATE",
  "exerciseHeader-string": "EXERCISE",
  "setsHeader-string": "SETS",
  "blockHeader-string": "BLOCK",
  "metricsHeader-string": "METRICS",
  "sets-string": "Sets",
  "setSingular-string": "Set",

  "clientName-string": "Client name",
  "contactNumber-string": "Contact number",
  "phone-string": "Phone",
  "gender-string": "Gender",
  "male-string": "Male",
  "female-string": "Female",
  "notesForCoach-string": "Notes for the coach",
  "deleteClient-string": "Delete Athlete",
  "deleteSampleAthlete-string": "Delete Sample Athlete",

  "deleteClientAlertTitle-string": "DELETE ATHLETE",
  "deleteClientAlertText-string": "Are you sure you want to delete the athlete? All chat messages, videos, audio recordings, and images will be permanently deleted.",

  "planification-string": "Program",
  "openBlockInProgram-string": "Open block in Program",
  "blockSummary-string": "Block Summary",
  "openBlockSummary-string": "Open block summary",
  "withoutBlocks-string": "No Blocks",
  "withoutBlocksText-string": "Create your first training block",
  "noMatchingBlocks-string": "No matching blocks",
  "noMatchingBlocksSubtitle-string": "Try a different search term",
  "makeActive-string": "Set as active",
  "editBlock-string": "Edit block",
  "copyBlock-string": "Duplicate first week of block",
  "copyFullBlock-string": "Duplicate entire block",
  "copyToAnotherClient-string": "Copy to another athlete",
  "copyToAClient-string": "Copy to an athlete",
  "newBlock-string": "New Block",
  "createBlock-string": "Create a new block",
  "copyOf-string": "Copy of",
  "editMacro-string": "Edit folder",
  "editFolderName-string": "Edit folder name",
  "createBlockInFolder-string": "Create block in folder",
  "folderRenameError-string": "Some folder blocks could not be renamed. Please try again.",
  "disableBlockFolderMoveSearchActive-string": "Clear search to move blocks between folders.",
  "blockMovedFolderTitle-string": "Block moved",
  "blockMovedFolderDescription-string": "\"{{blockName}}\" moved to {{folderName}}.",
  "blockMoveFolderErrorTitle-string": "Couldn't move block",
  "blockMoveFolderErrorDescription-string": "The block was returned to its previous folder.",
  "macrocycleTooltip-string": "A folder is a label you can add to blocks to group several blocks together.",
  "macrocyclePlaceholder-string": "Folder name...",

  "maximumWeeksReachedTitle-string": "MAXIMUM WEEKS REACHED",
  "maximumWeeksReachedText-string": "You've reached the maximum number of weeks allowed for a training block",

  "slotsNotAddedToWeekTitle-string": "UNASSIGNED SLOTS",
  "slotsNotAddedToWeekText-string": "Some slots have not been added to any workouts in week {{week}}. Are you sure you want to create a new week?",
  "slotsNotAddedToWeekAllWeeksText-string": "Some slots have not been added to any workouts in week {{week}}. Are you sure you want to create new weeks?",

  "accessoriesNotAddedToWeekTitle-string": "NO ACCESSORY EXERCISES",
  "accessoriesNotAddedToWeekText-string": "There are no accessory exercises in any workout for week {{week}}. Are you sure you want to create a new week without them?",
  "accessoriesNotAddedToWeekAllWeeksText-string": "There are no accessory exercises in any workout for week {{week}}. Are you sure you want to create new weeks without them?",

  "conflictingExercisesTitle-string": "SLOT OVERLAP",
  "conflictingExerciseText-string": "There is already an exercise with this slot in this week: \n{{slot}}",
  "conflictingExercisesText-string": "There are already exercises with these slots in this week: \n{{slots}}",

  "createFirstWeekWorkoutsTitle-string": "DELETE EXISTING WEEK 1 WORKOUTS",
  "createFirstWeekWorkoutsText-string": "There are already workouts in the first week of this block. Are you sure you want to delete them and generate new workouts based on the split?",

  "deleteBlockAlertTitle-string": "DELETE TRAINING BLOCK",
  "deleteBlockAlertText-string": "Type the name to delete the block",

  "deleteWeekAlertTitle-string": "DELETE WEEK",
  "deleteWeekAlertText-string": "Are you sure you want to delete all workouts for week {{week}}?",
  "deleteWeekWorkoutsTooltip-string": "Delete week workouts",

  "deleteExerciseAlertTitle-string": "DELETE EXERCISE",
  "deleteExerciseAlertText-string": "Are you sure you want to delete the exercise '{{itemName}}'?",
  "deleteExerciseWarningAlertText-string": "To delete '{{itemName}}', please open its workout session and remove it there.",

  "deleteProtocolAlertTitle-string": "DELETE EXERCISE",
  "deleteProtocolAlertText-string": "Are you sure you want to delete the exercise '{{itemName}}'?",
  "deleteProtocolFromWorkoutAlertText-string": "The exercise '{{itemName}}' is in workout '{{workoutName}}'. Are you sure you want to delete it?",

  "summaryOf-string": "Summary of {{name}}",
  "session-string": "SESSION",
  "protocol-string": "Protocol",
  "primary-string": "Primary",
  "secondary-string": "Secondary",
  "tertiary-string": "Tertiary",
  "quaternary-string": "Quaternary",
  "quinary-string": "Quinary",
  "notesAboutBlock-string": "Notes about the block",
  "blockAverages-string": "Block averages",
  "averageStressIndex-string": "Average S.I.",
  "averageTonnage-string": "Average tonnage",
  "averageSets-string": "Average sets",
  "averageNL-string": "Average NL",
  "volumeAndStress-string": "Volume & stress",
  "primarySessions-string": "Primary sessions",
  "bestSet-string": "Best set",
  "bestE1rm-string": "Best E1RM",
  "loadIncrease-string": "Load increase",

  "copyEntireBlock-string": "Copy entire block",

  "copyWeek-string": "Copy week",
  "copyFullWeek-string": "Copy full week",
  "copyTargetWeek-string": "Copy target",
  "copyActualToTargetWeek-string": "Copy actual to target",
  "actualToTarget-string": "Actual to target",
  "duplicateWeek-string": "Duplicate week",
  "configureWeeks-string": "Configure weeks",
  "duplicateWeekWithNumber-string": "Duplicate Week {{week}}",
  "duplicateWeekSubtitle-string": "Copying {{week}}",
  "duplicateWeekSelectFutureHint-string": "Select weeks to duplicate this week to:",
  "duplicateWeekCopyActualLabel-string": "Copy actual values to targets",
  "duplicateWeekCopyActualHelper-string": "Use Week {{week}} actual values as targets in the selected week.",
  "duplicateWeekSingleWeekOnly-string": "You can only select one week to copy actual values to targets.",
  "duplicateWeekInfo-string": "Slot progressions from the Dashboard will be applied to duplicated weeks.",
  "duplicateWeekWarningMissingSlotSingular-string": "The slot {{slots}} has not been added to any workout of week {{week}}.",
  "duplicateWeekWarningMissingSlotsPlural-string": "The slots {{slots}} have not been added to any workout of week {{week}}.",
  "duplicateWeekWarningQuestion-string": "Are you sure you want to duplicate week {{week}}?",
  "duplicateWeekWarningNoAccessory-string": "No workouts have accessory exercises.",
  "duplicateWeekBlockedWeekTooltip-string": "This week already contains workouts with exercises.",
  "duplicateWeekConfirm-string": "Duplicate",
  "duplicateWeekSuccessTitle-string": "Week duplicated",
  "duplicateWeekSuccessSingular-string": "Week {{sourceWeek}} duplicated to {{targetWeek}}",
  "duplicateWeekSuccessPlural-string": "Week {{sourceWeek}} duplicated to {{count}} weeks",
  "duplicateWeekToastTitle-string": "Week duplicated",
  "duplicateWeekToastDescription-string": "Duplicated {{sourceWeek}} to {{targetWeeks}}.",
  "weekHiddenToastTitle-string": "Week hidden",
  "weekHiddenToastDescription-string": "{{weekLabel}} is now hidden.",
  "weekShownToastTitle-string": "Week shown",
  "weekShownToastDescription-string": "{{weekLabel}} is now visible.",
  "copyExercisesWeek-string": "Copy exercises",
  "createPendingWeeks-string": "Create pending weeks",
  "createNextWeek-string": "Create next week",
  "createWeeksXtoY-string": "Create pending weeks ({{x}}-{{y}})",
  "addToCalendar-string": "Add to calendar",
  "workoutsSelected-string": "workouts selected",

  "duplicateExerciseTitle-string": "Duplicate Exercise",
  "duplicateExerciseSelectWorkouts-string": "Select workouts to duplicate this exercise to:",
  "duplicateExerciseInfo-string": "The exercise will be duplicated with all its sets and attributes to the selected workouts.",
  "duplicateExerciseConfirm-string": "Duplicate",
  "duplicateExerciseConfirmCount-string": "Duplicate to {{count}} workouts",
  "duplicateExerciseSuccessTitle-string": "Exercise duplicated",
  "duplicateExerciseSuccess-string": "{{exerciseName}} duplicated to {{count}} {{count, plural, one {workout} other {workouts}}}",
  "duplicateExerciseToastTitle-string": "Exercise duplicated",
  "duplicateExerciseToastDescription-string": "Added {{exerciseName}} to {{workouts}}.",
  "duplicateExerciseKeepOrder-string": "Keep same position in workout",
  "duplicateExerciseKeepOrderHint-string": "Exercise will be inserted at position #{{order}} in target workouts",
  "duplicateExerciseAppendOrderHint-string": "Exercise will be inserted at the end of target workouts",
  "duplicateExerciseProtocolSlotBlockedTitle-string": "Weeks blocked for this protocol",
  "duplicateExerciseProtocolSlotBlockedBody-string": "Weeks {{weeks}} already include {{protocolSlot}}.",
  "duplicateExerciseProtocolSlotBlockedBodySingular-string": "Week {{weeks}} already includes {{protocolSlot}}.",
  "duplicateExerciseSecondaryProtocolSlotBlockedBody-string": "{{protocolSlot}} #2 can only be copied to workouts that include {{protocolSlot}} #1.",
  "duplicateExerciseProtocolSlotOnePerWeekTooltip-string": "You have already selected a workout to add this slot in this week.",
  "weekAbbr-string": "W{{week}}",
  "noWorkoutsInBlock-string": "No workouts in this block",
  "exercise-string": "Exercise",
  "workoutWithNumber-string": "Workout #{{number}}",
  "allWorkouts-string": "All",
  "filterWorkouts-string": "Filter Workouts",
  "onlySlots-string": "Only slots",
  "hiddenExercisesCount-string_one": "+{{count}} exercise",
  "hiddenExercisesCount-string_other": "+{{count}} exercises",
  "showAll-string": "Show all",
  "showing-string": "Showing",
  "clipboard-string": "Clipboard",
  "viewClipboard-string": "View clipboard",
  "expandExercises-string": "Expand exercises",
  "collapseExercises-string": "Collapse exercises",
  "emptyClipboard-string": "Empty clipboard",
  "clipboardOneExercise-string": "1 exercise copied",
  "clipboardMultipleExercises-string": "{{count}} exercises copied",
  "clearAll-string": "Clear All",
  "libraryWorkout-string": "Library",
  "slots-string": "Slots",

  "createFirstWeekOfWorkouts-string": "Generate the first week of workouts based on the split",
  "createFirstWeekOfWorkoutsButton-string": "Create Week 1 Workouts",
  "firstWeekOfWorkoutsCreated-string": "There are already workouts with exercises in week 1",

  "linkExerciseToSlot-string": "LINK EXERCISE TO SLOT",
  "alreadyOneExerciseForSlot-string": "This slot already contains '{{exerciseName}}'. Do you also want to add this exercise?",
  "alreadyOneExerciseForSlotAnotherWorkout-string": "This slot already contains '{{exerciseName}}'. Both exercises need to be in the same workout before you can add this one.",
  "ThisSlotIsFull-string": "This slot already contains '{{firstExerciseName}} + {{secondExerciseName}}'.",
  "unlinkExerciseFromSlotWarningTitle-string": "UNLINK EXERCISE FROM SLOT",
  "unlinkExerciseFromSlotWarningText-string": "Are you sure you want to unlink the exercise '{{exerciseName}}' from the slot '{{slotName}}'? The exercise won't be deleted.",
  "unlinkExercisesFromSlotWarningText-string": "Are you sure you want to unlink the exercises '{{firstExerciseName}}' and '{{secondExerciseName}}' from the slot '{{slotName}}'? The exercises won't be deleted.",
  "exerciseLinkedToastTitle-string": "Exercise linked",
  "exerciseLinkedToastDescription-string": "Linked {{exerciseName}} to {{slotName}}.",
  "exerciseUnlinkedToastTitle-string": "Exercise unlinked",
  "exerciseUnlinkedToastDescription-string": "Unlinked {{exerciseName}} from {{slotName}}.",

  "addSlot-string": "Add a Slot",
  "selectExerciseAndModifiers": "Select an exercise and its modifiers",
  "protocols-string": "Protocols",
  "primarySquat-string": "Primary Squat",
  "secondarySquat-string": "Secondary Squat",
  "tertiarySquat-string": "Tertiary Squat",
  "quaternarySquat-string": "Quaternary Squat",
  "quinarySquat-string": "Quinary Squat",
  "primaryBenchPress-string": "Primary Bench Press",
  "secondaryBenchPress-string": "Secondary Bench Press",
  "tertiaryBenchPress-string": "Tertiary Bench Press",
  "quaternaryBenchPress-string": "Quaternary Bench Press",
  "quinaryBenchPress-string": "Quinary Bench Press",
  "primaryDeadlift-string": "Primary Deadlift",
  "secondaryDeadlift-string": "Secondary Deadlift",
  "tertiaryDeadlift-string": "Tertiary Deadlift",
  "quaternaryDeadlift-string": "Quaternary Deadlift",
  "quinaryDeadlift-string": "Quinary Deadlift",
  "lift-string": "Lift",
  "priority-string": "Priority",
  "setsDots-string": "Sets:",
  "target-string": "TARGET",
  "actual-string": "ACTUAL",
  "actualExerciseCard-string": "ACTUAL",
  "weight-string": "WEIGHT",
  "reps-string": "REPS",
  "rir-string": "RIR",
  "rpe-string": "RPE",
  "priorityHeader-string": "P",
  "showActual-string": "Show Actual",
  "hideActual-string": "Hide Actual",
  "weekWithNumberAndDay-string": "Week {{week}} - {{day}}",
  "dayWithNumber-string": "Day {{number}}",
  "linkSlotWithExercise-string": "Do you want to link the slot '{{slotName}}' to the exercise from the workout ",
  "linkSlotSelectWorkouts-string": "Select the workouts containing the exercise '{{slotName}}' to link the exercises to the slot",
  "linkSlotSameWorkout1-string": "Select the exercises of the workout ",
  "linkSlotSameWorkout2-string": " you want to link to the slot '{{slotName}}'",
  "notesDots-string": "Notes...",

  "primaryF-string": "Primary",
  "secondaryF-string": "Secondary",
  "tertiaryF-string": "Tertiary",
  "quaternaryF-string": "Quaternary",
  "quinaryF-string": "Quinary",

  "primaryM-string": "Primary",
  "secondaryM-string": "Secondary",
  "tertiaryM-string": "Tertiary",
  "quaternaryM-string": "Quaternary",
  "quinaryM-string": "Quinary",

  "modifiers-string": "Modifiers",
  "history-string": "History",
  "seeMore-string": "See more",
  "emptyHistoryTitle-string": "No Exercise History",
  "emptyHistoryText-string": "This exercise has not been logged yet",
  "selectExercisesTitle-string": "Select Exercises",
  "selectExercisesText-string": "Select predefined exercises or a workout from the workout library",
  "selectExercises&SlotsText-string": "Select block slots, predefined exercises or a workout from the workout library",
  "selectExercisesLibrary-string": "Select predefined exercises",
  "exerciseProtocols-string": "{{name}} protocols",
  "exerciseSlots-string": "{{name}} Slots",
  "showPredefinedExercises-string": "Show predefined exercises",
  "showWorkoutLibrary-string": "Show workout library",

  "deleteWorkoutAlert-string": "Are you sure you want to delete the workout?",
  "withoutDate-string": "Without date",
  "moveUp-string": "Move up",
  "moveDown-string": "Move down",
  "copyToAnotherWeek-string": "Copy to another week",
  "moveToAnotherWeek-string": "Move to another week",
  "exportToLibrary-string": "Export to library",
  "exportWorkoutToLibraryDisabledTooltip-string": "Add exercises to export the workout to your library",

  "emptyAttributesTitle-string": "No Modifiers",
  "noAttributesFoundText-string": "No modifiers found",

  "emptyExercisesTitle-string": "No Exercises",
  "emptyExercisesText-string": "Add exercises to the workout",
  "noExercisesFoundText-string": "No exercises found",
  "statisticsSearchPerformedExercisesPrompt-string": "Search performed exercises",
  "searchExercisePlaceholder-string": "Search exercise",
  "suggestedExercises-string": "Suggested",
  "exerciseNotInAllBlocks-string": "Exercise is not present in every selected block",
  "searchingEllipsis-string": "Searching...",
  "addExercises-string": "Add exercises",

  "highPriority-string": "High priority",
  "mediumPriority-string": "Medium priority",
  "lowPriority-string": "Low priority",

  "nameOfBlockDots-string": "Name of block: ",

  "newWeekName-string": "New week name...",
  "showStats-string": "Show Stats",
  "hideStats-string": "Hide Stats",
  "hideWeek-string": "Hide week",
  "showWeek-string": "Show week",
  "editWeekName-string": "Edit week name",
  "linkExerciseToSlotTooltip-string": "Link exercise to slot",
  "unlinkExerciseFromSlotTooltip-string": "Unlink exercise from slot",
  "requestVideo-string": "Request video",
  "dontRequestVideo-string": "Don't request video",
  "copyToNextSet-string": "Copy to next set",
  "deleteSet-string": "Delete set",
  "copyTargetToActual-string": "Copy target to actual",
  "setPriority-string": "Set priority",
  "addSet-string": "Add set",
  "copySets-string": "Copy sets",
  "pasteSets-string": "Paste sets",
  "exercisesCopied-string": "Exercises copied",
  "exercisesCopiedDescription-string": "Copied exercises from {{workoutName}}.",
  "exerciseCopied-string": "Exercise copied",
  "exerciseCopiedDescription-string": "Copied {{exerciseName}}.",
  "setsCopied-string": "Sets copied",
  "setsCopiedDescription-string": "Copied sets from {{exerciseName}}.",
  "exercisesPasted-string": "Exercises pasted",
  "exercisesPastedDescription-string": "Pasted exercises to {{workoutName}}.",
  "setsPasted-string": "Sets pasted",
  "setsPastedDescription-string": "Pasted sets to {{exerciseName}}.",
  "editExercise-string": "Edit exercise",
  "copyExercise-string": "Copy exercise",
  "move-string": "Move",
  "editProtocol-string": "Edit protocol",
  "addProtocolPlaceholder-string": "Add protocol…",
  "unknownProtocolFormat-string": "Unknown protocol format: \"{{segment}}\"",
  "protocolError-string": "Protocol error",
  "editNote-string": "Edit note",
  "editWorkout-string": "Edit workout",
  "editTargetWeight-string": "Edit target weight",
  "editTargetReps-string": "Edit target reps",
  "editTargetRPE-string": "Edit target RPE",
  "addVideoLink-string": "Add video link",
  "editVideoLink-string": "Edit video link",
  "slotExplanation-string": "A slot is a main lift (squat, bench, deadlift) or a variation of these movements.",
  "resetCompletedAthletes-string": "Reset completed athletes",
  "filterAthletes-string": "Filter athletes",
  "startAddingSlotsBeforeShowingActual-string": "Start adding slots to show the actual of sets",
  "showActualOfSets-string": "Show the actual of sets",
  "hideActualOfSets-string": "Hide the actual of sets",
  "copyWeekSlotsAndProtocols-string": "Copy week slots and protocols",
  "copySlotAndProtocol-string": "Copy slot and protocol",

  "protocolsGuide-string": "Protocols Guide",
  "protocolsGuideDescription-string": "Create sets by typing any of the following formats:",
  "protocolsFixedRepsRPE-string": "Fixed Reps & RPE",
  "protocolsFixedWeightReps-string": "Fixed Weight & Reps",
  "protocolsCombineWith-string": "Combine protocols with the",
  "protocolsCombineSymbol-string": "+",
  "protocolsCombineExample-string": "e.g. \"x4 @7 + 2x4 @5\"",
  "startAddingSlotsBelow-string": "Start adding slots below",
  "protocolMoveWeekLimit-string": "Slots must stay in the same week",
  "protocolMoveWeekLimitDescription-string": "Exercise linked to slots cannot be moved to other weeks",
  "protocolMovePackToast-string": "Also moved {{pairedName}}",
  "exerciseMovedToastTitle-string": "Exercise moved",
  "exerciseMovedToastTitlePlural-string": "Exercises moved",
  "exerciseMovedToastDescriptionSameWorkout-string": "Moved {{exerciseName}} to #{{position}}.",
  "exerciseMovedToastDescriptionSameWeek-string": "Moved {{exerciseName}} to {{workoutName}} (#{{position}}).",
  "exerciseMovedToastDescriptionCrossWeek-string": "Moved {{exerciseName}} to {{workoutName}} · {{weekLabel}} (#{{position}}).",
  "exerciseMovedToastDescriptionPluralSameWorkout-string": "Moved {{firstExerciseName}} and {{secondExerciseName}} to #{{firstPosition}}, #{{secondPosition}}.",
  "exerciseMovedToastDescriptionPluralSameWeek-string": "Moved {{firstExerciseName}} and {{secondExerciseName}} to {{workoutName}} (#{{firstPosition}}, #{{secondPosition}}).",
  "exerciseMovedToastDescriptionPluralCrossWeek-string": "Moved {{firstExerciseName}} and {{secondExerciseName}} to {{workoutName}} · {{weekLabel}} (#{{firstPosition}}, #{{secondPosition}}).",
  "maxExercisesPerWorkoutReached-string": "Exercise limit reached",
  "maxExercisesPerWorkoutDescription-string": "You can have up to {{limit}} exercises per workout.",
  "maxSetsPerExerciseReached-string": "Set limit reached",
  "maxSetsPerExerciseDescription-string": "You can have up to {{limit}} sets per exercise.",
  "maxWorkoutsPerWeekReached-string": "Workout limit reached",
  "maxWorkoutsPerWeekDescription-string": "You can have up to {{limit}} workouts per week.",

  "nutrition-string": "Nutrition",
  "nutritionPlanName-string": "Plan name",
  "nutritionPlanNotes-string": "Description",
  "newNutritionPlanName-string": "New Nutrition Plan...",
  "newNutritionPlanNotes-string": "Add a description to the nutrition pla...",
  "meals-string": "Meals",
  "mealsDistribution-string": "Meals overview",
  "deleteMeal-string": "Delete Meal",
  "mealNotes-string": "Add a description to the meal...",
  "addMeal-string": "Add Meal",
  "addFoodOptions-string": "Add food options",
  "addOption-string": "Add option",
  "addFood-string": "Add Food",
  "copyNutritionPlan-string": "Copy Nutrition Plan",

  "foodOption-string": "Option {{optionNumber}}",

  "goal-string": "Goal",
  "setMacroGoals-string": "Set Macro Goals",
  "byGrams-string": "By grams",
  "byPercentages-string": "By percentages",

  "breakfast-string": "Breakfast",
  "lunch-string": "Lunch",
  "dinner-string": "Dinner",
  "snack-string": "Snack",

  "calories-string": "Calories",
  "carbs-string": "Carbs",
  "carbohydrates-string": "Carbohydrates",
  "protein-string": "Protein",
  "fats-string": "Fats",

  "newPlan-string": "New Plan",

  "numberOfMeals-string": "{{number}} meals",

  "foods-string": "Foods",
  "nutritionPlans-string": "Nutrition Plans",
  "newFood-string": "New Food",

  "createFood-string": "Create a new food",
  "editFood-string": "Edit a food",
  "quantityDots-string": "Quantity:",
  "caloriesDots-string": "Calories:",
  "carbsDots-string": "Carbs:",
  "carbohydratesDots-string": "Carbohydrates:",
  "proteinDots-string": "Protein:",
  "fatsDots-string": "Fats:",
  "foodBrand-string": "Brand...",
  "foodStore-string": "Store...",

  "quantity-string": "Quantity",

  "addEquivalences-string": "Add Equivalences",
  "customFoods-string": "Custom Foods",
  "searchFoods-string": "Search foods...",
  "clientHistoryFoodsDots-string": "Client's last used foods:",

  "deleteCoachFoodAlertTitle-string": "DELETE FOOD",
  "deleteCoachFoodAlertText-string": "Are you sure you want to delete the food from the library?",

  "deleteNutritionPlanAlertTitle-string": "DELETE PLAN",
  "deleteNutritionPlanAlertText-string": "Are you sure you want to delete the nutrition plan?",

  "TITOL ADD PREDEFINEDS": "",

  "newPredefinedExercise-string": "New Predefined Exercise",
  "exerciseNamePlaceholder-string": "Exercise name...",
  "editPredefinedExercise-string": "Edit the predefined exercise",
  "addPredefinedExercise-string": "Create a new predefined exercise",
  "typeDots-string": "Type: ",

  "newPredefinedAttribute-string": "New Modifier",
  "modifierNamePlaceholder-string": "Modifier name...",
  "editPredefinedAttribute-string": "Edit the predefined modifier",
  "addPredefinedAttribute-string": "Create a new predefined modifier",
  "titleDots-string": "Title: ",
  "subtitleDots-string": "Subtitle: ",

  "TITOL TIPUS DE MODIFICADORS": "",

  "equipment-string": "Equipment",
  "tempo-string": "Tempo",
  "rom-string": "Range of Motion",
  "stanceGrip-string": "Stance/Grip",
  "loadAccomodation-string": "Load Accomodation",
  "accessories-string": "Accessories",
  "other-string": "Other",

  "boards-string": "Boards",
  "grip-string": "Grip",
  "stance-string": "Stance",
  "bands-string": "Bands",
  "reverseBands-string": "Reverse Bands",

  "TITOL TIPUS DE EXERCICIS": "",

  "kneeDominant-string": "Knee Dominant",
  "hipDominant-string": "Hip Dominant",
  "horizontalPush-string": "Horizontal Push",
  "verticalPush-string": "Vertical Push",
  "horizontalPull-string": "Horizontal Pull",
  "verticalPull-string": "Vertical Pull",
  "weightlifting-string": "Weightlifting",

  "TITOL LLISTA EXERCICIS": "",

  "squat-string": "Squat",
  "hackSquat-string": "Hack Squat",
  "bulgarianSplitSquat-string": "Bulgarian Split Squat",
  "splitSquat-string": "Split Squat",
  "frontSquat-string": "Front Squat",
  "platzSquat-string": "Platz Squat",
  "zercherSquat-string": "Zercher Squat",
  "legCurls-string": "Leg Curls",
  "legExtension-string": "Leg Extension",
  "legPress-string": "Leg Press",
  "beltSquat-string": "Belt Squat",
  "lunges-string": "Lunges",
  "deadlift-string": "Deadlift",
  "conventionalDeadlift-string": "Conventional Deadlift",
  "sumoDeadlift-string": "Sumo Deadlift",
  "romanianDeadlift-string": "Romanian Deadlift",
  "singleLegRDL-string": "Single Leg RDL",
  "stiffLegRDL-string": "Stiff Leg RDL",
  "goodMorning-string": "Good Morning",
  "hipThrust-string": "Hip Thrust",
  "hyperextensions-string": "Hyperextensions",
  "gluteHamRaise-string": "Glute Ham Raise",
  "abductorMachine-string": "Abductor Machine",
  "benchPress-string": "Bench Press",
  "inclineBenchPress-string": "Incline Bench Press",
  "declineBenchPress-string": "Decline Bench Press",
  "machinePress-string": "Machine Press",
  "floorPress-string": "Floor Press",
  "jmPress-string": "J.M. Press",
  "inclinePushUp-string": "Incline Push Up",
  "pushUp-string": "Push Up",
  "tricepExtensions-string": "Tricep Extensions",
  "tricepPushdown-string": "Tricep Pushdown",
  "flies-string": "Flies",
  "skullCrushers-string": "Skull Crushers",
  "military-string": "Military",
  "dips-string": "Dips",
  "handstandPushUp-string": "Handstand Push Up",
  "landminePress-string": "Landmine Press",
  "cableRow-string": "Cable Row",
  "tBarRow-string": "T-Bar Row",
  "chestSupportedRow-string": "Chest Supported Row",
  "pendlayRow-string": "Pendlay Row",
  "inclineRow-string": "Incline Row",
  "sealRow-string": "Seal Row",
  "oneArmRow-string": "One Arm Row",
  "row-string": "Row",
  "facePull-string": "Face Pull",
  "invertedBWRows-string": "Inverted BW Rows",
  "reverseFlies-string": "Reverse Flies",
  "pullUp-string": "Pull Up",
  "pullDown-string": "Pull Down",
  "pullOver-string": "Pull Over",
  "uprightRow-string": "Upright Row",
  "curls-string": "Curls",
  "inclineCurls-string": "Incline Curls",
  "hammerCurls-string": "Hammer Curls",
  "lateralRaise-string": "Lateral Raise",
  "frontRaise-string": "Front Raise",
  "abWheel-string": "Ab Wheel",
  "copenhagenPlank-string": "Copenhagen Plank",
  "sidePlank-string": "Side Plank",
  "plank-string": "Plank",
  "crunchAbdominal-string": "Abdominal Crunch",
  "landmineRotation-string": "Landmine Rotation",
  "calfRaise-string": "Calf Raise",
  "legLowers-string": "Leg Lowers",
  "pallofPress-string": "Pallof Press",
  "run-string": "Run",
  "cleanPull-string": "Clean Pull",

  "TITOL LLISTA MODIFICADORS": "",

  "Barbell-string": "Barbell",
  "Dumbbell-string": "Dumbbell",
  "SafetyBar-string": "Safety Bar",
  "TrapBar-string": "Trap Bar",
  "ZBar-string": "Z Bar",
  "Cable-string": "Cable",
  "Machine-string": "Machine",
  "SmithMachine-string": "Smith Machine",
  "Beltless-string": "Beltless",

  "Tempo-string": "Tempo",
  "TouchAndGo-string": "Touch & Go",
  "1ctPause-string": "1ct Pause",
  "2ctPause-string": "2ct Pause",
  "3ctPause-string": "3ct Pause",
  "5ctPause-string": "5ct Pause",
  "300Tempo-string": "300 Tempo",
  "400Tempo-string": "400 Tempo",
  "500Tempo-string": "500 Tempo",
  "600Tempo-string": "600 Tempo",
  "303Tempo-string": "303 Tempo",
  "320Tempo-string": "320 Tempo",
  "530Tempo-string": "530 Tempo",
  "Low2ctPause-string": "Low 2ct Pause",
  "Low3ctPause-string": "Low 3ct Pause",
  "High2ctPause-string": "High 2ct Pause",
  "High3ctPause-string": "High 3ct Pause",

  "LowPin-string": "Low Pin",
  "MiddlePin-string": "Middle Pin",
  "HighPin-string": "High Pin",
  "Deficit-string": "Deficit",
  "5cmDeficit-string": "5cm Deficit",
  "10cmDeficit-string": "10cm Deficit",
  "LowBlock-string": "Low Block",
  "HighBlock-string": "High Block",
  "Spoto-string": "Spoto",

  "HalfBoard-string": "Half Board",
  "1Board-string": "1 Board",
  "2Boards-string": "2 Boards",
  "3Boards-string": "3 Boards",
  "4Boards-string": "4 Boards",
  "5Boards-string": "5 Boards",
  "Board-string": "Board",

  "Standard-string": "Standard",
  "HighBar-string": "High Bar",
  "LowBar-string": "Low Bar",
  "SnatchGrip-string": "Snatch Grip",
  "ReverseGrip-string": "Reverse Grip",
  "Pronated-string": "Pronated",
  "Supinated-string": "Supinated",

  "VeryCloseGrip-string": "Very Close Grip",
  "CloseGrip-string": "Close Grip",
  "WideGrip-string": "Wide Grip",
  "VeryWideGrip-string": "Very Wide Grip",
  "NeutralGrip-string": "Neutral Grip",

  "VeryCloseStance-string": "Very Close Stance",
  "CloseStance-string": "Close Stance",
  "WideStance-string": "Wide Stance",
  "VeryWideStance-string": "Very Wide Stance",
  "InSplit-string": "In Split",

  "Chains-string": "Chains",
  "WeightReleasers-string": "Weight Releasers",

  "Band-string": "Band",

  "LightBand-string": "Light Band",
  "AverageBand-string": "Average Band",
  "StrongBand-string": "Strong Band",

  "ReverseLightBand-string": "Reverse Light Band",
  "ReverseAverageBand-string": "Reverse Average Band",
  "ReverseStrongBand-string": "Reverse Strong Band",
  "ReverseBand-string": "Reverse Band",

  "Belt-string": "Belt",
  "KneeWraps-string": "Knee Wraps",
  "KneeSleeves-string": "Knee Sleeves",
  "Slingshot-string": "Slingshot",
  "Straps-string": "Straps",

  "Larsen-string": "Larsen",
  "FeetUp-string": "Feet Up",
  "Clusters-string": "Clusters",
  "SingleArm-string": "Single Arm",
  "SingleLeg-string": "Single Leg",
  "Seated-string": "Seated",
  "Standing-string": "Standing",
  "Lying-string": "Lying",
  "Unilateral-string": "Unilateral",
  "Kodama-string": "Kodama",

  "chats-string": "Chats",
  "messages-string": "Messages",
  "messagePlaceholder-string": "Message...",
  "openEmojiPicker-string": "Open emoji picker",
  "closeEmojiPicker-string": "Close emoji picker",
  "coachReplied-string": "Coach replied",
  "youReplied-string": "You replied",
  "nowMessageCoach-string": "You can now message your coach!",
  "replyPlaceholder-string": "Reply...",
  "coach-string": "Coach",
  "now-string": "Now",
  "yesterday-string": "Yesterday",
  "photo-string": "Photo",
  "viewVideo-string": "View video",
  "video-string": "Video",
  "changeVideo-string": "Change video",
  "deleteVideo-string": "Delete video",
  "NoFileFoundTitle-string": "No File Found",
  "NoFileFoundText-string": "This media might have been deleted",
  "videoNotAvailableTitle-string": "Video Not Available",
  "videoNotAvailableText-string": "This video is currently not available",
  "videoCodecPlaybackIssueTitle-string": "We're already fixing this",
  "videoCodecPlaybackIssueText-string": "Your browser can't play this video format right now. We're fixing it over the next few hours, and this video will play again very soon.",
  "videoStillLoadingText-string": "This video is still loading",
  "imageNotAvailableTitle-string": "Image Not Available",
  "imageNotAvailableText-string": "This image is currently not available",
  "downloadComplete-string": "Saved successfully",
  "downloadError-string": "Error saving the file",
  "sendingVideo-string": "Sending Video...",
  "sendingVideoInChat-string": "Sending {{item}} video in chat...",
  "sendingVideosInChat-string": "Sending {{item}} videos in chat...",
  "videoTooLong-string": "Video must be under 2 minutes",
  "addVideo-string": "Upload",
  "videoAlertTitle-string": "UPLOAD VIDEO",
  "videoAlertText-string": "Your coach hasn't requested a video for this set. Do you want to upload it anyway?",
  "waitingToSendMessage-string": "Waiting to send messages...",
  "permissionsAlertTitle-string": "WEB PERMISSIONS",
  "permissionsAlertText-string": "Please grant Efort Coach the necessary permissions in your browser settings",
  "emptyChatTitle-string": "Welcome to Efort Chat",
  "emptyChatText-string": "Send messages, audio, and images, and receive videos of each set",
  "noStorageLeftTitle-string": "INSUFFICIENT STORAGE",
  "noStorageLeftText-string": "The device doesn't have enough storage, and some chat features may be affected",
  "videoDeletedSuccessfully-string": "Video Deleted Successfully",
  "errorDeletingVideo-string": "Error Deleting Video",
  "errorDeletingVideoOffline-string": "Internet Required to Delete Video",
  "selectChatTitle-string": "Select a Chat",
  "selectChatText-string": "Please select a chat to view messages",
  "markAsUnread-string": "Mark as unread"
}
